(function () {
  "use strict";

  if (window.spiSynonymSearchV2) return;
  window.spiSynonymSearchV2 = true;

  const synonymGroups = [
   [
      "control panel", "display", "lcd panel", "module lcd",
      "operation panel", "touch panel", "touchscreen", "bedieningspaneel",
      "bedieningsscherm", "bedienfeld", "bedienpanel", "bedieneinheit",
      "anzeige", "panneau de commande", "panneau de contrôle", "écran",
      "afficheur", "pannello di controllo", "pannello comandi",
      "panel de control", "panel de mando", "pantalla", "ctrl panel",
      "operating panel", "ui panel", "bedienpaneel", "bedienungsfeld",
      "pannello operativo", "controlpanel", "lcdpanel", "modulelcd",
      "operationpanel", "touchpanel", "panneau de controle", "ecran",
      "pannellocomandi", "ctrlpanel", "operatingpanel", "uipanel",
      "pannellooperativo", "betjeningspanel", "kontrolpanel",
      "berøringsskærm", "beroeringsskaerm", "beroringsskaerm", "touchskærm",
      "touchskaerm", "kontrollpanel", "manöverpanel", "manoeverpanel",
      "manoverpanel", "pekskärm", "pekskaerm", "pekskarm", "styrpanel",
      "berøringsskjerm", "beroeringsskjerm", "beroringsskjerm",
      "berøringspanel", "beroeringspanel", "beroringspanel", "ohjauspaneeli",
      "käyttöpaneeli", "kaeyttoepaneeli", "kayttopaneeli", "kosketusnäyttö",
      "kosketusnaeyttoe", "kosketusnaytto", "stjórnborð", "stjornbord",
      "snertiskjár", "snertiskjar", "stjórnskjár", "stjornskjar"
    ],
    [
      "dc controller", "dc controller pca", "dc control pcb",
      "dc control pca", "dc control", "dc controller board",
      "dc controller pcb", "dc besturingskaart", "dc controllerkaart",
      "dc steuerplatine", "dc controller platine", "dc steuerung",
      "carte contrôleur dc", "carte de contrôle dc", "scheda controller dc",
      "scheda di controllo dc", "placa controladora dc",
      "tarjeta controladora dc", "dcc", "dc pcb", "dc board", "dc ctrl",
      "dc kaart", "dccontroller", "dccontrol", "dcbesturingskaart",
      "dccontrollerkaart", "dcsteuerplatine", "dcsteuerung",
      "carte controleur dc", "carte de controle dc", "dcpcb", "dcboard",
      "dcctrl", "dckaart", "dc styrekort", "dcstyrekort", "dc kontrolkort",
      "dckontrolkort", "dc styrkort", "dcstyrkort", "dc kontrollkort",
      "dckontrollkort", "dc ohjainkortti", "dcohjainkortti",
      "dc stýrispjald", "dcstýrispjald", "dc styrispjald", "dcstyrispjald"
    ],
    [
      "fan", "ventilator", "cooling fan", "koelventilator", "lüfter",
      "kühllüfter", "ventilateur", "ventola", "ventilatore", "ventilador",
      "fans", "case fan", "cpu fan", "fan module", "fan assembly",
      "fan assy", "ventilatoren", "ventilateurs", "ventole", "ventiladores",
      "coolingfan", "luefter", "lufter", "kuehlluefter", "kuhllufter",
      "casefan", "cpufan", "fanmodule", "fanassembly", "fanassy", "blæser",
      "blaeser", "blæsere", "blaesere", "køleblæser", "koeleblaeser",
      "koleblaeser", "fläkt", "flaekt", "flakt", "fläktar", "flaektar",
      "flaktar", "kylfläkt", "kylflaekt", "kylflakt", "vifte", "vifter",
      "kjølevifte", "kjoelevifte", "kjolevifte", "tuuletin", "tuulettimet",
      "jäähdytystuuletin", "jaeaehdytystuuletin", "jaahdytystuuletin",
      "puhallin", "vifta", "viftur", "kælivifta", "kaelivifta"
    ],
    [
      "fuser", "fixing", "fuserunit", "fusing", "fuser unit", "fixing unit",
      "fuser assembly", "fixeereenheid", "fuseereenheid", "fixiereinheit",
      "fixierung", "unité de fusion", "module de fusion", "fusore",
      "unità di fusione", "gruppo fusore", "fusor", "unidad fusora",
      "unidad de fusión", "fuser assy", "fixing assembly", "fixing assy",
      "fusers", "fuser module", "fixeerunit", "fixiereinheiten", "fusori",
      "fixingunit", "fuserassembly", "unite de fusion", "unita di fusione",
      "gruppofusore", "unidadfusora", "unidad de fusion", "fuserassy",
      "fixingassembly", "fixingassy", "fusermodule", "fikseringsenhed",
      "fuserenhed", "fixeringsenhet", "fuserenhet", "fikseringsenhet",
      "kiinnitysyksikkö", "kiinnitysyksikkoe", "kiinnitysyksikko",
      "kiinnitin", "festieining", "hitaeining"
    ],
    [
      "fuser kit", "fuserkit", "fixing kit", "fixingkit",
      "fuser maintenance kit", "fixeerkit", "fixierkit", "fixiereinheit kit",
      "kit de fusion", "kit unité de fusion", "kit fusore",
      "kit gruppo fusore", "kit de fusor", "kit fusor", "fuser maint kit",
      "fuser maintenance", "fixeerset", "fixiereinheitkit",
      "kit unite de fusion", "kitfusore", "kitfusor", "fusermaintenance",
      "fikseringskit", "fixeringskit", "fikseringssett", "fuser sett",
      "fusersett", "kiinnitysyksikkösarja", "kiinnitysyksikkoesarja",
      "kiinnitysyksikkosarja", "festieiningarsett"
    ],
    [
      "ssd", "solidstate", "solid state", "solid state drive",
      "solid state disk", "ssd schijf", "ssd festplatte",
      "solid state laufwerk", "disque ssd", "disque à semi-conducteurs",
      "disco ssd", "unità a stato solido", "unidad de estado sólido",
      "disco de estado sólido", "ssds", "ssd schijven", "ssd festplatten",
      "ssd laufwerk", "disques ssd", "dischi ssd", "discos ssd", "nvme",
      "nvme ssd", "m.2", "m2", "m.2 ssd", "msata", "sata ssd", "sas ssd",
      "ssdschijf", "ssdfestplatte", "disquessd", "disque a semi conducteurs",
      "disque a semi-conducteurs", "disque a semiconducteurs",
      "disque à semi conducteurs", "disque à semiconducteurs", "discossd",
      "unita a stato solido", "unidad de estado solido",
      "disco de estado solido", "ssdschijven", "ssdfestplatten",
      "ssdlaufwerk", "disquesssd", "dischissd", "discosssd", "nvmessd",
      "m.2ssd", "satassd", "sasssd", "ssd disk", "ssddisk", "ssd harddisk",
      "ssdharddisk", "ssd hårddisk", "ssdhårddisk", "ssd haarddisk",
      "ssdhaarddisk", "ssd levy", "ssdlevy", "ssd diskur", "ssddiskur"
    ],
    [
      "hdd", "harddisk", "hard disk", "hard-disk", "schijf", "hard drive",
      "harddrive", "harde schijf", "festplatte", "disque dur",
      "disco rigido", "disco duro", "harddisks", "hard disks", "hard drives",
      "hdds", "hard disk drive", "harde schijven", "festplatten",
      "festplattenlaufwerk", "disques durs", "dischi rigidi", "discos duros",
      "hd", "disk", "disks", "sas hdd", "sata hdd", "sas disk", "sata disk",
      "schijven", "platte", "disque", "disco", "hardeschijf", "disquedur",
      "discorigido", "discoduro", "harddrives", "hardeschijven",
      "disquesdurs", "dischirigidi", "discosduros", "sashdd", "satahdd",
      "sasdisk", "satadisk", "harddiske", "hårddisk", "haarddisk",
      "hårddiskar", "haarddiskar", "harddiskar", "harddisker", "kiintolevy",
      "kovalevy", "kiintolevyt", "harður diskur", "harðurdiskur",
      "hardur diskur", "hardurdiskur", "harðdiskur", "harddiskur", "diskur"
    ],
    [
      "hvps", "high voltage power supply", "hv power supply", "hv psu",
      "hoogspanningsvoeding", "hochspannungsnetzteil",
      "hochspannungsversorgung", "alimentation haute tension",
      "alimentatore alta tensione", "fuente de alta tensión",
      "fuente de alto voltaje", "hv", "hv board", "high voltage",
      "hoogspanning", "hochspannung", "hvpsu", "fuente de alta tension",
      "hvboard", "highvoltage", "højspændingsforsyning",
      "hoejspaendingsforsyning", "hojspaendingsforsyning",
      "högspänningsaggregat", "hoegspaenningsaggregat",
      "hogspanningsaggregat", "högspänningsmatning", "hoegspaenningsmatning",
      "hogspanningsmatning", "høyspenningsforsyning",
      "hoeyspenningsforsyning", "hoyspenningsforsyning", "suurjännitelähde",
      "suurjaennitelaehde", "suurjannitelahde", "háspennuaflgjafi",
      "haspennuaflgjafi"
    ],
    [
      "keyboard", "toetsenbord", "tastur", "tastatur", "clavier", "tastiera",
      "teclado", "kb", "kbd", "keyb", "keyboards", "laptop keyboard",
      "notebook keyboard", "toetsenborden", "tastaturen", "claviers",
      "tastiere", "teclados", "laptopkeyboard", "notebookkeyboard",
      "tastaturer", "tangentbord", "näppäimistö", "naeppaeimistoe",
      "nappaimisto", "näppäimistöt", "naeppaeimistoet", "nappaimistot",
      "lyklaborð", "lyklabord"
    ],
    [
      "laser/scanner", "lsu", "laser scanner", "laser scanner unit",
      "laser unit", "scanner unit", "lasereenheid", "laserscanner",
      "lasereinheit", "laserscannereinheit", "unité laser", "bloc laser",
      "scanner laser", "unità laser", "gruppo laser", "unidad láser",
      "escáner láser", "laser assy", "laser assembly",
      "laser scanner assembly", "laserunit", "scannerunit", "unite laser",
      "unitelaser", "unitélaser", "bloclaser", "scannerlaser", "unita laser",
      "unitalaser", "unitàlaser", "gruppolaser", "unidad laser",
      "unidadlaser", "unidadláser", "escaner laser", "escanerlaser",
      "escánerláser", "laserassy", "laserassembly", "laserenhed",
      "laserscannerenhed", "laserenhet", "laseryksikkö", "laseryksikkoe",
      "laseryksikko", "leysieining"
    ],
    [
      "lvps", "low voltage power supply", "lv power supply", "lv psu",
      "laagspanningsvoeding", "niederspannungsnetzteil",
      "niederspannungsversorgung", "alimentation basse tension",
      "alimentatore bassa tensione", "fuente de baja tensión",
      "fuente de bajo voltaje", "lv", "lv board", "low voltage",
      "laagspanning", "niederspannung", "lvpsu", "fuente de baja tension",
      "lvboard", "lowvoltage", "lavspændingsforsyning",
      "lavspaendingsforsyning", "lågspänningsaggregat",
      "laagspaenningsaggregat", "lagspanningsaggregat",
      "lavspenningsforsyning", "pienjännitelähde", "pienjaennitelaehde",
      "pienjannitelahde", "lágspennuaflgjafi", "lagspennuaflgjafi"
    ],
    [
      "maintenance kits", "maintenance kit", "mk", "onderhoudskit",
      "wartungskit", "onderhoudsset", "wartungsset", "wartungseinheit",
      "kit de maintenance", "kit d'entretien", "kit di manutenzione",
      "kit de mantenimiento", "maint kit", "pm kit", "service kit",
      "onderhoudssets", "wartungskits", "maintenancekits", "maintenancekit",
      "maintkit", "pmkit", "servicekit", "vedligeholdelseskit",
      "vedligeholdelsessæt", "vedligeholdelsessaet", "underhållskit",
      "underhaallskit", "underhallskit", "underhållssats", "underhaallssats",
      "underhallssats", "vedlikeholdssett", "vedlikeholdskit", "huoltosarja",
      "huoltopaketti", "viðhaldssett", "vidhaldssett"
    ],
    [
      "mp", "handinvoer", "hand invoer", "multipurpose", "multi purpose",
      "mp tray", "multipurpose tray", "bypass", "manual feed",
      "handinvoerlade", "multifunctionele lade", "mehrzweckfach",
      "mehrzweckzufuhr", "manueller einzug", "bac multifonction",
      "bac polyvalent", "introduction manuelle", "vassoio multiuso",
      "alimentazione manuale", "bandeja multiuso", "bandeja multipropósito",
      "alimentación manual", "mpt", "mpf", "mp lade", "bypass tray",
      "manual feed tray", "tray 1", "lade 1", "fach 1", "mptray",
      "multipurposetray", "manualfeed", "multifunctionelelade",
      "manuellereinzug", "bacmultifonction", "bacpolyvalent",
      "introductionmanuelle", "vassoiomultiuso", "alimentazionemanuale",
      "bandejamultiuso", "bandeja multiproposito", "bandejamultiproposito",
      "bandejamultipropósito", "alimentacion manual", "alimentacionmanual",
      "alimentaciónmanual", "mplade", "bypasstray", "tray1", "lade1",
      "fach1", "manuel indføring", "manuelindføring", "manuel indfoering",
      "manuelindfoering", "manuel indforing", "manuelindforing",
      "universalbakke", "universalfack", "manuell matning", "manuellmatning",
      "multifack", "manuell mating", "manuellmating", "flerbruksskuff",
      "monikäyttölokero", "monikaeyttoelokero", "monikayttolokero",
      "käsinsyöttö", "kaesinsyoettoe", "kasinsyotto", "handmötun",
      "handmoetun", "handmotun", "fjölnotabakki", "fjoelnotabakki",
      "fjolnotabakki"
    ],
    [
      "pca", "pcb", "pc board", "printed circuit board", "circuit board",
      "printplaat", "platine", "leiterplatte", "carte électronique",
      "circuit imprimé", "scheda elettronica", "circuito stampato",
      "placa de circuito", "circuito impreso", "placa electrónica", "pcba",
      "pcbs", "printplaten", "platinen", "leiterplatten", "pcboard",
      "circuitboard", "carte electronique", "carteelectronique",
      "carteélectronique", "circuit imprime", "circuitimprime",
      "circuitimprimé", "schedaelettronica", "circuitostampato",
      "circuitoimpreso", "placa electronica", "placaelectronica",
      "placaelectrónica", "printkort", "kredsløbskort", "kredsloebskort",
      "kredslobskort", "kretskort", "piirilevy", "rafrásaspjald",
      "rafrasaspjald", "prentplata"
    ],
    [
      "roller kit", "rollerkit", "kit roller", "rollenset", "rollerset",
      "rollenkit", "invoerrollen", "rollensatz", "einzugsrollen",
      "kit de rouleaux", "kit rouleaux", "kit rulli", "kit de rodillos",
      "rollers", "rollen", "rouleaux", "rulli", "rodillos", "roller set",
      "kitroller", "kitrouleaux", "kitrulli", "rullesæt", "rullesaet",
      "valsesæt", "valsesaet", "rullsats", "rullesett", "rullasarja",
      "rúllusett", "rullusett"
    ],
    [
      "transfer belt", "transferbelt", "itb", "intermediate transfer belt",
      "transferband", "overdrachtsband", "transfereinheit",
      "courroie de transfert", "cinghia di trasferimento",
      "nastro di trasferimento", "cinta de transferencia",
      "banda de transferencia", "transfer unit", "itb unit", "itb assy",
      "itb kit", "transferunit", "itbunit", "itbassy", "itbkit",
      "overførselsbånd", "overfoerselsbaand", "overforselsband",
      "transferbælte", "transferbaelte", "överföringsband",
      "oeverfoeringsband", "overforingsband", "overføringsbelte",
      "overfoeringsbelte", "overforingsbelte", "siirtohihna",
      "flutningsbelti"
    ],
    [
      "power supply", "powersupply", "psu", "voeding", "power supply unit",
      "voedingseenheid", "netzteil", "stromversorgung", "alimentation",
      "bloc d'alimentation", "alimentatore", "fuente de alimentación",
      "power supplies", "psus", "voedingen", "voedingseenheden", "netzteile",
      "alimentations", "blocs d'alimentation", "alimentatori",
      "fuentes de alimentación", "ps", "server psu", "redundant psu",
      "hot plug psu", "voedingsunit", "stroomvoorziening",
      "fuente de alimentacion", "powersupplies", "fuentes de alimentacion",
      "serverpsu", "redundantpsu", "strømforsyning", "stroemforsyning",
      "stromforsyning", "strømforsyninger", "stroemforsyninger",
      "stromforsyninger", "nätaggregat", "naetaggregat", "nataggregat",
      "strömförsörjning", "stroemfoersoerjning", "stromforsorjning",
      "virtalähde", "virtalaehde", "virtalahde", "virtalähteet",
      "virtalaehteet", "virtalahteet", "aflgjafi", "spennugjafi"
    ],
    [
      "batteries", "battery", "laptop battery", "notebook battery", "accu",
      "accus", "batterij", "batterijen", "laptop accu", "akku", "akkus",
      "batterien", "notebook akku", "batterie", "batterie portable",
      "batteria", "batteria notebook", "batería", "baterías",
      "batería portátil", "batt", "bat", "battery pack", "accupack",
      "akkupack", "batteria laptop", "laptopbattery", "notebookbattery",
      "laptopaccu", "notebookakku", "batterieportable", "batterianotebook",
      "bateria", "baterias", "bateria portatil", "bateriaportatil",
      "bateríaportátil", "batterypack", "batterialaptop", "batteri",
      "batterier", "laptopbatteri", "akut", "paristo", "kannettavan akku",
      "kannettavanakku", "rafhlaða", "rafhlada", "rafhlöður", "rafhloedur",
      "rafhlodur"
    ],
    [
      "cd dvd drive", "cd/dvd drive", "dvd drive", "cd drive",
      "optical drive", "dvd writer", "dvd burner", "dvd rw", "cd rom",
      "dvd station", "cd station", "optische drive", "dvd brander",
      "dvd laufwerk", "cd laufwerk", "optisches laufwerk", "dvd brenner",
      "lecteur dvd", "lecteur cd", "lecteur optique", "graveur dvd",
      "unità dvd", "unità ottica", "lettore dvd", "masterizzatore dvd",
      "unidad de dvd", "unidad óptica", "lector de dvd", "grabadora de dvd",
      "dvd", "cd", "odd", "dvdrw", "dvd-rw", "dvd+rw", "blu-ray", "bluray",
      "bd drive", "brander", "brenner", "graveur", "cd/dvddrive", "dvddrive",
      "cddrive", "opticaldrive", "dvdwriter", "dvdburner", "cdrom",
      "dvdstation", "cdstation", "optischedrive", "dvdbrander",
      "dvdlaufwerk", "cdlaufwerk", "optischeslaufwerk", "dvdbrenner",
      "lecteurdvd", "lecteurcd", "lecteuroptique", "graveurdvd", "unita dvd",
      "unitadvd", "unitàdvd", "unita ottica", "unitaottica", "unitàottica",
      "lettoredvd", "masterizzatoredvd", "unidad optica", "unidadoptica",
      "unidadóptica", "blu ray", "bddrive", "dvd drev", "dvddrev", "cd drev",
      "cddrev", "optisk drev", "optiskdrev", "dvd enhet", "dvdenhet",
      "cd enhet", "cdenhet", "optisk enhet", "optiskenhet", "dvd stasjon",
      "dvdstasjon", "cd stasjon", "cdstasjon", "optisk stasjon",
      "optiskstasjon", "dvd asema", "dvdasema", "cd asema", "cdasema",
      "optinen asema", "optinenasema", "dvd drif", "dvddrif", "geisladrif"
    ],
    [
      "system boards", "system board", "systemboard", "motherboard",
      "motherboards", "mainboard", "mainboards", "logic board", "mobo",
      "moederbord", "moederborden", "systeembord", "hauptplatine",
      "hauptplatinen", "systemplatine", "carte mère", "cartes mères",
      "carte système", "scheda madre", "schede madri", "scheda di sistema",
      "placa base", "placas base", "placa madre", "tarjeta madre", "mb",
      "mainbord", "sysboard", "system brd", "moederbordje", "systemboards",
      "logicboard", "carte mere", "cartemere", "cartemère", "cartes meres",
      "cartesmeres", "cartesmères", "carte systeme", "cartesysteme",
      "cartesystème", "schedamadre", "schedemadri", "placabase",
      "placasbase", "placamadre", "tarjetamadre", "systembrd", "bundkort",
      "systemkort", "moderkort", "hovedkort", "emolevy", "emolevyt",
      "móðurborð", "modurbord"
    ],
    [
      "diverse onderdelen", "overige onderdelen", "diversen",
      "losse onderdelen", "miscellaneous parts", "misc parts",
      "miscellaneous", "other parts", "various parts", "diverse teile",
      "sonstige teile", "verschiedene teile", "sonstiges", "pièces diverses",
      "divers", "autres pièces", "parti varie", "ricambi vari", "varie",
      "piezas varias", "repuestos varios", "varios", "misc", "overig",
      "overige", "other", "allerlei", "diverseonderdelen",
      "overigeonderdelen", "losseonderdelen", "miscellaneousparts",
      "miscparts", "otherparts", "variousparts", "diverseteile",
      "sonstigeteile", "verschiedeneteile", "pieces diverses",
      "piecesdiverses", "piècesdiverses", "autres pieces", "autrespieces",
      "autrespièces", "partivarie", "ricambivari", "piezasvarias",
      "repuestosvarios", "diverse dele", "diversedele", "øvrige dele",
      "øvrigedele", "oevrige dele", "oevrigedele", "ovrige dele",
      "ovrigedele", "andre dele", "andredele", "diverse delar",
      "diversedelar", "övriga delar", "övrigadelar", "oevriga delar",
      "oevrigadelar", "ovriga delar", "ovrigadelar", "diverse deler",
      "diversedeler", "andre deler", "andredeler", "øvrige deler",
      "øvrigedeler", "oevrige deler", "oevrigedeler", "ovrige deler",
      "ovrigedeler", "sekalaiset osat", "sekalaisetosat", "muut osat",
      "muutosat", "ýmsir hlutir", "ýmsirhlutir", "ymsir hlutir",
      "ymsirhlutir", "aðrir hlutir", "aðrirhlutir", "adrir hlutir",
      "adrirhlutir"
    ],
    [
      "kabels en netsnoeren", "kabels", "kabel", "netsnoer", "netsnoeren",
      "stroomkabel", "voedingskabel", "cables and power cords", "cables",
      "cable", "power cords", "power cord", "power cable", "mains cable",
      "kabel und netzkabel", "netzkabel", "stromkabel", "câbles", "câble",
      "cordon d'alimentation", "câble d'alimentation", "cordon secteur",
      "cavi", "cavo", "cavo di alimentazione", "cavi di alimentazione",
      "cable de alimentación", "cables de alimentación", "snoer", "snoeren",
      "netzleitung", "kaltgerätekabel", "c13", "c13 kabel", "c13 cable",
      "c14", "iec cable", "power lead", "powercords", "powercord",
      "powercable", "mainscable", "cable d'alimentation", "cordonsecteur",
      "cable de alimentacion", "cables de alimentacion", "kaltgeraetekabel",
      "kaltgeratekabel", "c13kabel", "c13cable", "ieccable", "powerlead",
      "kabler", "strømkabel", "stroemkabel", "strømkabler", "stroemkabler",
      "stromkabler", "netledning", "kablar", "strömkabel", "nätkabel",
      "naetkabel", "natkabel", "elkabel", "strømledning", "stroemledning",
      "stromledning", "kaapeli", "kaapelit", "virtajohto", "virtakaapeli",
      "kapall", "kaplar", "rafmagnssnúra", "rafmagnssnura"
    ],
    [
      "memory", "ram", "memory module", "memory modules", "dimm", "sodimm",
      "so-dimm", "geheugen", "werkgeheugen", "geheugenmodule",
      "ram geheugen", "arbeitsspeicher", "speicher", "speichermodul",
      "ram speicher", "mémoire", "mémoire vive", "barrette mémoire",
      "barrette de ram", "memoria", "memoria ram", "modulo di memoria",
      "banco di memoria", "módulo de memoria", "mem", "ddr", "ddr2", "ddr3",
      "ddr4", "ddr5", "rdimm", "lrdimm", "udimm", "ecc", "ecc memory",
      "ram module", "geheugenreep", "geheugenrepen", "speicherriegel",
      "ram riegel", "barrette", "barrettes", "memorie", "memorias",
      "memorymodule", "memorymodules", "so dimm", "ramgeheugen",
      "ramspeicher", "memoire", "memoire vive", "memoirevive", "mémoirevive",
      "barrette memoire", "barrettememoire", "barrettemémoire", "memoriaram",
      "modulo de memoria", "eccmemory", "rammodule", "ramriegel",
      "hukommelse", "ram hukommelse", "ramhukommelse", "hukommelsesmodul",
      "arbejdshukommelse", "minne", "arbetsminne", "minnesmodul",
      "ram minne", "ramminne", "minnemodul", "muisti", "keskusmuisti",
      "muistimoduuli", "ram muisti", "rammuisti", "minni", "vinnsluminni",
      "minniskubbur"
    ],
    [
      "network products", "networking products", "networking", "network",
      "network equipment", "network card", "network adapter", "nic",
      "lan card", "netwerkproducten", "netwerk", "netwerkkaart",
      "netwerkapparatuur", "netzwerkprodukte", "netzwerk", "netzwerkkarte",
      "netzwerkadapter", "produits réseau", "réseau", "carte réseau",
      "équipement réseau", "prodotti di rete", "scheda di rete",
      "apparati di rete", "productos de red", "tarjeta de red",
      "equipos de red", "net", "lan", "ethernet", "ethernet card",
      "ethernet adapter", "network interface card", "nics", "nic card",
      "netwerkadapter", "networkproducts", "networkingproducts",
      "networkequipment", "networkcard", "networkadapter", "lancard",
      "produits reseau", "produitsreseau", "produitsréseau", "reseau",
      "carte reseau", "cartereseau", "carteréseau", "equipement reseau",
      "equipementreseau", "équipementréseau", "ethernetcard",
      "ethernetadapter", "niccard", "netværk", "netvaerk", "netværkskort",
      "netvaerkskort", "netværksprodukter", "netvaerksprodukter",
      "netværksadapter", "netvaerksadapter", "nätverk", "naetverk",
      "natverk", "nätverkskort", "naetverkskort", "natverkskort",
      "nätverksprodukter", "naetverksprodukter", "natverksprodukter",
      "nettverk", "nettverkskort", "nettverksprodukter", "verkko",
      "verkkokortti", "verkkotuotteet", "verkkosovitin", "netkort",
      "netbúnaður", "netbunadur"
    ],
    [
      "processors", "processor", "cpu", "cpus", "microprocessor",
      "processoren", "prozessor", "prozessoren", "processeur", "processeurs",
      "processore", "processori", "procesador", "procesadores",
      "microprocesador", "proc", "procs", "cpu's", "processorer",
      "prosessori", "suoritin", "prosessorit", "örgjörvi", "oergjoervi",
      "orgjorvi", "örgjörvar", "oergjoervar", "orgjorvar"
    ],
    [
      "heatsinks", "heatsink", "heat sink", "heat sinks", "cpu cooler",
      "koelblok", "koelelement", "koellichaam", "kühlkörper", "cpu kühler",
      "dissipateur", "dissipateur thermique", "dissipatore",
      "dissipatore di calore", "disipador", "disipador de calor", "hs",
      "cooler", "coolers", "cooling", "koeler", "koeling", "kühlung",
      "refroidissement", "raffreddamento", "refrigeración", "cpucooler",
      "kuehlkoerper", "kuhlkorper", "cpu kuehler", "cpu kuhler",
      "cpukuehler", "cpukuhler", "cpukühler", "dissipateurthermique",
      "kuehlung", "kuhlung", "refrigeracion", "køleplade", "koeleplade",
      "koleplade", "køleprofil", "koeleprofil", "koleprofil", "cpu køler",
      "cpukøler", "cpu koeler", "cpukoeler", "cpu koler", "cpukoler",
      "kylfläns", "kylflaens", "kylflans", "kylflänsar", "kylflaensar",
      "kylflansar", "cpu kylare", "cpukylare", "kjøleribbe", "kjoeleribbe",
      "kjoleribbe", "kjøleelement", "kjoeleelement", "kjoleelement",
      "cpu kjøler", "cpukjøler", "cpu kjoeler", "cpukjoeler", "cpu kjoler",
      "cpukjoler", "jäähdytyssiili", "jaeaehdytyssiili", "jaahdytyssiili",
      "jäähdytin", "jaeaehdytin", "jaahdytin", "prosessorin jäähdytin",
      "prosessorinjäähdytin", "prosessorin jaeaehdytin",
      "prosessorinjaeaehdytin", "prosessorin jaahdytin",
      "prosessorinjaahdytin", "kæliplata", "kaeliplata", "kælir", "kaelir"
    ],
    [
      "lcd", "lcd screen", "lcd display", "laptop screen", "notebook screen",
      "lcd scherm", "beeldscherm", "laptopscherm", "lcd bildschirm",
      "bildschirm", "notebook bildschirm", "écran lcd", "dalle lcd",
      "schermo lcd", "display lcd", "pannello lcd", "pantalla lcd",
      "panel lcd", "screen", "screens", "scherm", "schermen", "lcds",
      "lcd's", "tft", "led screen", "led display", "laptop display",
      "notebook display", "ips panel", "lcdscreen", "lcddisplay",
      "laptopscreen", "notebookscreen", "lcdscherm", "lcdbildschirm",
      "notebookbildschirm", "ecran lcd", "ecranlcd", "écranlcd", "dallelcd",
      "schermolcd", "displaylcd", "pannellolcd", "pantallalcd", "panellcd",
      "ledscreen", "leddisplay", "laptopdisplay", "notebookdisplay",
      "ipspanel", "skærm", "skaerm", "lcd skærm", "lcdskærm", "lcd skaerm",
      "lcdskaerm", "laptopskærm", "laptopskaerm", "skärm", "skarm",
      "lcd skärm", "lcdskärm", "lcd skarm", "lcdskarm", "laptopskärm",
      "laptopskarm", "skjerm", "lcd skjerm", "lcdskjerm", "laptopskjerm",
      "näyttö", "naeyttoe", "naytto", "lcd näyttö", "lcdnäyttö",
      "lcd naeyttoe", "lcdnaeyttoe", "lcd naytto", "lcdnaytto",
      "kannettavan näyttö", "kannettavannäyttö", "kannettavan naeyttoe",
      "kannettavannaeyttoe", "kannettavan naytto", "kannettavannaytto",
      "skjár", "skjar", "lcd skjár", "lcdskjár", "lcd skjar", "lcdskjar",
      "fartölvuskjár", "fartoelvuskjar", "fartolvuskjar"
    ],
    [
      "oled", "oled screen", "oled display", "oled panel", "amoled",
      "oled scherm", "oled bildschirm", "écran oled", "dalle oled",
      "schermo oled", "pantalla oled", "panel oled", "oledscreen",
      "oleddisplay", "oledpanel", "oledscherm", "oledbildschirm",
      "ecran oled", "ecranoled", "écranoled", "dalleoled", "schermooled",
      "pantallaoled", "paneloled", "oled skærm", "oledskærm", "oled skaerm",
      "oledskaerm", "oled skärm", "oledskärm", "oled skarm", "oledskarm",
      "oled skjerm", "oledskjerm", "oled näyttö", "olednäyttö",
      "oled naeyttoe", "olednaeyttoe", "oled naytto", "olednaytto",
      "oled skjár", "oledskjár", "oled skjar", "oledskjar"
    ],
    [
      "ac adapter", "ac adaptor", "power adapter", "laptop charger",
      "charger", "netadapter", "laptoplader", "oplader", "lader",
      "netzadapter", "notebook netzteil", "ladegerät", "steckernetzteil",
      "adaptateur secteur", "chargeur", "chargeur portable", "adattatore ac",
      "alimentatore notebook", "caricabatterie", "adaptador de corriente",
      "adaptador ac", "cargador", "cargador portátil", "adapter", "adapters",
      "adaptateur", "adattatore", "adaptador", "laptop adapter",
      "notebook adapter", "laptop psu", "voedingsadapter", "usb c charger",
      "usb-c adapter", "acadapter", "acadaptor", "poweradapter",
      "laptopcharger", "notebooknetzteil", "ladegeraet", "ladegerat",
      "adaptateursecteur", "chargeurportable", "adattatoreac",
      "alimentatorenotebook", "adaptadorac", "cargador portatil",
      "cargadorportatil", "cargadorportátil", "laptopadapter",
      "notebookadapter", "laptoppsu", "usb c adapter", "usb-cadapter",
      "usbc adapter", "usbcadapter", "strømadapter", "stroemadapter",
      "stromadapter", "laptop oplader", "laptopoplader", "laddare",
      "nätadapter", "naetadapter", "natadapter", "laptopladdare", "laturi",
      "verkkolaturi", "virtasovitin", "hleðslutæki", "hledslutaeki",
      "straumbreytir"
    ],
    [
      "laptop", "laptops", "notebook", "notebooks", "ordinateur portable",
      "pc portable", "portable", "portatile", "computer portatile",
      "portátil", "ordenador portátil", "ordinateurportable", "pcportable",
      "computerportatile", "portatil", "ordenador portatil",
      "ordenadorportatil", "ordenadorportátil", "bærbar", "baerbar",
      "bærbar computer", "bærbarcomputer", "baerbar computer",
      "baerbarcomputer", "bærbar pc", "bærbarpc", "baerbar pc", "baerbarpc",
      "bärbar dator", "bärbardator", "baerbar dator", "baerbardator",
      "barbar dator", "barbardator", "bärbar", "barbar", "bærbar datamaskin",
      "bærbardatamaskin", "baerbar datamaskin", "baerbardatamaskin",
      "kannettava", "kannettava tietokone", "kannettavatietokone", "läppäri",
      "laeppaeri", "lappari", "fartölva", "fartoelva", "fartolva",
      "fartölvur", "fartoelvur", "fartolvur"
    ],
    [
      "desktop", "desktops", "pc", "computer", "desktop pc", "tower",
      "rechner", "ordinateur", "ordinateur de bureau", "pc fisso",
      "computer desktop", "ordenador", "ordenador de sobremesa",
      "pc de escritorio", "desktoppc", "pcfisso", "computerdesktop",
      "stationær computer", "stationærcomputer", "stationaer computer",
      "stationaercomputer", "stationær pc", "stationærpc", "stationaer pc",
      "stationaerpc", "dator", "stationär dator", "stationärdator",
      "stationaer dator", "stationaerdator", "stationar dator",
      "stationardator", "datamaskin", "stasjonær pc", "stasjonærpc",
      "stasjonaer pc", "stasjonaerpc", "tietokone", "pöytäkone",
      "poeytaekone", "poytakone", "pöytätietokone", "poeytaetietokone",
      "poytatietokone", "tölva", "toelva", "tolva", "borðtölva",
      "bordtoelva", "bordtolva"
    ],
    [
      "workstation", "workstations", "ws", "werkstation",
      "station de travail", "estación de trabajo", "estacion de trabajo",
      "arbejdsstation", "arbetsstation", "arbeidsstasjon", "työasema",
      "tyoeasema", "tyoasema", "vinnustöð", "vinnustoed", "vinnustod"
    ],
    [
      "thin client", "thin clients", "terminal", "client léger",
      "cliente ligero", "thinclient", "thinclients", "client leger",
      "clientleger", "clientléger", "clienteligero", "tynd klient",
      "tyndklient", "tunn klient", "tunnklient", "tynn klient", "tynnklient",
      "kevytpääte", "kevytpaeaete", "kevytpaate", "ohut asiakas",
      "ohutasiakas", "þunnbiðlari", "thunnbidlari"
    ],
    [
      "all in one", "all-in-one", "aio", "alles in een", "alles-in-één",
      "tout-en-un", "tutto in uno", "todo en uno", "allinone",
      "alles in één", "alles-in-een", "allesineen", "allesinéén",
      "tout en un", "toutenun", "alt i en", "alt-i-en", "allt i ett",
      "allt-i-ett", "kaikki yhdessä", "kaikkiyhdessä", "kaikki yhdessae",
      "kaikkiyhdessae", "kaikki yhdessa", "kaikkiyhdessa", "allt í einu",
      "allt i einu"
    ],
    [
      "tablet", "tablets", "tab", "tablette", "tableta", "surfplatta",
      "surfplattor", "nettbrett", "tabletti", "taulutietokone",
      "spjaldtölva", "spjaldtoelva", "spjaldtolva"
    ],
    [
      "smartphone", "smartphones", "phone", "mobile", "gsm", "mobiel",
      "telefoon", "handy", "téléphone", "cellulare", "telefonino", "móvil",
      "celular", "teléfono", "telephone", "movil", "telefono",
      "mobiltelefon", "mobil", "telefon", "älypuhelin", "aelypuhelin",
      "alypuhelin", "matkapuhelin", "puhelin", "kännykkä", "kaennykkae",
      "kannykka", "snjallsími", "snjallsimi", "farsími", "farsimi", "sími",
      "simi"
    ],
    [
      "monitor", "monitors", "monitoren", "computer monitor", "pc monitor",
      "flatscreen", "flat screen", "moniteur", "moniteurs", "écran pc",
      "schermo pc", "monitores", "pantalla de ordenador", "computermonitor",
      "pcmonitor", "ecran pc", "ecranpc", "écranpc", "schermopc",
      "computerskærm", "computerskaerm", "pc skærm", "pcskærm", "pc skaerm",
      "pcskaerm", "fladskærm", "fladskaerm", "bildskärm", "bildskaerm",
      "bildskarm", "datorskärm", "datorskaerm", "datorskarm", "dataskjerm",
      "pc skjerm", "pcskjerm", "flatskjerm", "tietokonenäyttö",
      "tietokonenaeyttoe", "tietokonenaytto", "tölvuskjár", "toelvuskjar",
      "tolvuskjar"
    ],
    [
      "printer", "printers", "drucker", "imprimante", "imprimantes",
      "stampante", "stampanti", "impresora", "impresoras", "printere",
      "skrivare", "skriver", "skrivere", "tulostin", "tulostimet",
      "prentari", "prentarar"
    ],
    [
      "mfp", "multifunction printer", "multifunction", "multifunctional",
      "multifunctionele printer", "multifunktionsdrucker",
      "imprimante multifonction", "multifonction", "multifunzione",
      "multifunción", "impresora multifunción", "multifunctionprinter",
      "multifunctioneleprinter", "imprimantemultifonction", "multifuncion",
      "impresora multifuncion", "impresoramultifuncion",
      "impresoramultifunción", "multifunktionsprinter",
      "multifunktionsskrivare", "multifunksjonsskriver", "monitoimitulostin",
      "monitoimilaite", "fjölnotaprentari", "fjoelnotaprentari",
      "fjolnotaprentari"
    ],
    [
      "copier", "copiers", "copy machine", "kopieerapparaat",
      "kopieermachine", "kopierer", "photocopieur", "copieur",
      "fotocopiatrice", "fotocopiadora", "copymachine", "kopimaskine",
      "kopimaskiner", "kopiator", "kopieringsmaskin", "kopimaskin",
      "kopiokone", "ljósritunarvél", "ljosritunarvel"
    ],
    [
      "plotter", "plotters", "large format printer", "grootformaat printer",
      "großformatdrucker", "traceur", "plóter", "grootformaatprinter",
      "grossformatdrucker", "ploter", "storformatprinter",
      "storformatsskrivare", "storformatskriver", "suurkokotulostin",
      "stórsniðsprentari", "storsnidsprentari"
    ],
    [
      "scanner", "scanners", "flatbed scanner", "document scanner",
      "flatbed", "documentscanner", "dokumentenscanner", "numériseur",
      "escáner", "flatbedscanner", "numeriseur", "escaner", "skanner",
      "skannere", "dokumentskanner", "flatbäddsskanner", "flatbaeddsskanner",
      "flatbaddsskanner", "skanneri", "asiakirjaskanneri", "skanni"
    ],
    [
      "server", "servers", "srv", "rack server", "tower server", "serveur",
      "serveurs", "servidor", "servidores", "rackserver", "towerserver",
      "servere", "servrar", "tjener", "palvelin", "palvelimet", "netþjónn",
      "netthjonn", "þjónn", "thjonn"
    ],
    [
      "blade", "blades", "blade server", "server blade", "lame serveur",
      "servidor blade", "bladeserver", "serverblade", "lameserveur",
      "servidorblade", "bladserver", "blade palvelin", "bladepalvelin"
    ],
    [
      "nas", "network attached storage", "netwerkopslag", "netzwerkspeicher",
      "stockage réseau", "archiviazione di rete", "almacenamiento en red",
      "stockage reseau", "stockagereseau", "stockageréseau", "netværkslager",
      "netvaerkslager", "nätverkslagring", "naetverkslagring",
      "natverkslagring", "nettverkslagring", "verkkotallennin", "verkkolevy",
      "netgeymsla"
    ],
    [
      "san", "storage array", "disk array", "storage", "opslag",
      "opslagsysteem", "speichersystem", "baie de stockage", "stockage",
      "cabina di storage", "almacenamiento", "sistema de almacenamiento",
      "storagearray", "diskarray", "lagring", "lagringssystem",
      "tallennusjärjestelmä", "tallennusjaerjestelmae",
      "tallennusjarjestelma", "levyjärjestelmä", "levyjaerjestelmae",
      "levyjarjestelma", "gagnageymsla", "geymslukerfi"
    ],
    [
      "tape drive", "tape", "lto", "streamer", "tape unit", "bandstation",
      "tapestation", "bandlaufwerk", "lecteur de bande", "unità nastro",
      "unità a nastro", "unidad de cinta", "tapedrive", "tapeunit",
      "unita nastro", "unitanastro", "unitànastro", "unita a nastro",
      "båndstation", "baandstation", "bandenhet", "båndstasjon",
      "baandstasjon", "bandstasjon", "nauha-asema", "segulbandsdrif"
    ],
    [
      "tape cartridge", "data cartridge", "lto tape", "lto cartridge",
      "datatape", "datacartridge", "datenkassette", "bandkassette",
      "cartouche de données", "cartouche lto", "cartuccia dati",
      "cartucho de datos", "tapecartridge", "ltotape", "ltocartridge",
      "cartouche de donnees", "cartouchelto", "cartucciadati",
      "datakassette", "båndkassette", "baandkassette", "bandkassett",
      "datakassett", "båndkassett", "baandkassett", "nauhakasetti",
      "segulbandsspóla", "segulbandsspola"
    ],
    [
      "tape library", "autoloader", "tape autoloader", "tapebibliotheek",
      "bandbibliothek", "bibliothèque de bandes", "libreria nastro",
      "librería de cintas", "tapelibrary", "tapeautoloader",
      "bibliotheque de bandes", "librerianastro", "libreria de cintas",
      "båndbibliotek", "baandbibliotek", "bandbibliotek", "nauhakirjasto",
      "segulbandasafn"
    ],
    [
      "ups", "uninterruptible power supply", "noodstroomvoeding", "usv",
      "unterbrechungsfreie stromversorgung", "onduleur",
      "gruppo di continuità", "sai",
      "sistema de alimentación ininterrumpida",
      "unterbrechungsfreiestromversorgung", "gruppo di continuita",
      "sistema de alimentacion ininterrumpida", "nødstrømsforsyning",
      "noedstroemsforsyning", "nodstromsforsyning",
      "afbrydelsesfri strømforsyning", "afbrydelsesfristrømforsyning",
      "afbrydelsesfri stroemforsyning", "afbrydelsesfristroemforsyning",
      "afbrydelsesfri stromforsyning", "afbrydelsesfristromforsyning",
      "avbrottsfri kraftförsörjning", "avbrottsfrikraftförsörjning",
      "avbrottsfri kraftfoersoerjning", "avbrottsfrikraftfoersoerjning",
      "avbrottsfri kraftforsorjning", "avbrottsfrikraftforsorjning",
      "reservkraft", "avbruddsfri strømforsyning",
      "avbruddsfristrømforsyning", "avbruddsfri stroemforsyning",
      "avbruddsfristroemforsyning", "avbruddsfri stromforsyning",
      "avbruddsfristromforsyning", "nødstrøm", "noedstroem", "nodstrom",
      "ups laite", "upslaite", "varavirtalähde", "varavirtalaehde",
      "varavirtalahde", "keskeytymätön virransyöttö",
      "keskeytymätönvirransyöttö", "keskeytymaetoen virransyoettoe",
      "keskeytymaetoenvirransyoettoe", "keskeytymaton virransyotto",
      "keskeytymatonvirransyotto", "varaaflgjafi"
    ],
    [
      "pdu", "power distribution unit", "power strip", "rack stekkerdoos",
      "stekkerdoos", "stroomverdeler", "steckdosenleiste",
      "rack steckdosenleiste", "stromverteiler", "multiprise",
      "multiprise rack", "ciabatta", "presa multipla", "regleta",
      "regleta rack", "powerstrip", "rackstekkerdoos",
      "racksteckdosenleiste", "multipriserack", "presamultipla",
      "regletarack", "stikdåse", "stikdaase", "stikdase", "strømskinne",
      "stroemskinne", "stromskinne", "grenuttag", "strömskena",
      "stroemskena", "stromskena", "grenuttak", "jatkojohto",
      "virranjakoyksikkö", "virranjakoyksikkoe", "virranjakoyksikko",
      "pistorasiarima", "fjöltengi", "fjoeltengi", "fjoltengi"
    ],
    [
      "rack", "server rack", "19 inch rack", "serverkast", "19 inch kast",
      "rackkast", "serverschrank", "netzwerkschrank", "19 zoll schrank",
      "baie serveur", "armoire serveur", "baie informatique", "armadio rack",
      "armadio server", "armario rack", "armario de servidores", "bastidor",
      "serverrack", "baieserveur", "armoireserveur", "baieinformatique",
      "armadiorack", "armadioserver", "armariorack", "serverskab",
      "rackskab", "19 tommer skab", "serverskåp", "serverskaap",
      "serverskap", "rackskåp", "rackskaap", "rackskap", "19 tums skåp",
      "19 tums skaap", "19 tums skap", "palvelinkaappi", "räkki", "raekki",
      "rakki", "19 tuuman kaappi", "netþjónaskápur", "netthjonaskapur"
    ],
    [
      "raid controller", "raid card", "raid", "storage controller",
      "smart array", "perc", "raid kaart", "raid controllerkaart",
      "raid-controller", "raid karte", "contrôleur raid", "carte raid",
      "controller raid", "scheda raid", "controladora raid", "tarjeta raid",
      "raidcontroller", "raidcard", "storagecontroller", "smartarray",
      "raidkaart", "raidcontrollerkaart", "raidkarte", "controleur raid",
      "controleurraid", "contrôleurraid", "carteraid", "controllerraid",
      "schedaraid", "controladoraraid", "tarjetaraid", "raid kort",
      "raidkort", "raid kontroller", "raidkontroller", "raid ohjain",
      "raidohjain", "raid kortti", "raidkortti", "raid stýring",
      "raidstýring", "raid styring", "raidstyring"
    ],
    [
      "hba", "host bus adapter", "fibre channel", "fiber channel", "fc card",
      "fc hba", "fibre channel kaart", "fibre channel karte",
      "carte fibre channel", "scheda fibre channel", "tarjeta fibre channel",
      "fibrechannel", "fiberchannel", "fccard", "fchba",
      "fibre channel kort", "fibre channel kortti"
    ],
    [
      "bbu", "battery backup unit", "raid battery", "cache battery", "fbwc",
      "raid batterij", "raid batterie", "batterie cache", "batteria cache",
      "batería raid", "raidbattery", "cachebattery", "raidbatterij",
      "raidbatterie", "batteriecache", "batteriacache", "bateria raid",
      "bateriaraid", "bateríaraid", "raid batteri", "raidbatteri",
      "cache batteri", "cachebatteri", "raid akku", "raidakku",
      "välimuistiakku", "vaelimuistiakku", "valimuistiakku"
    ],
    [
      "cache module", "raid cache", "flash cache", "cachemodule",
      "cache modul", "module cache", "modulo cache", "módulo de caché",
      "raidcache", "flashcache", "cachemodul", "modulecache", "modulocache",
      "modulo de cache", "välimuistimoduuli", "vaelimuistimoduuli",
      "valimuistimoduuli", "skyndiminni"
    ],
    [
      "management card", "remote management", "ilo", "idrac", "bmc", "ipmi",
      "managementkaart", "managementkarte", "carte de gestion",
      "scheda di gestione", "tarjeta de gestión", "managementcard",
      "remotemanagement", "tarjeta de gestion", "administrationskort",
      "fjernadministration", "fjärrhantering", "fjaerrhantering",
      "fjarrhantering", "hanteringskort", "administrasjonskort",
      "fjernstyring", "hallintakortti", "etähallinta", "etaehallinta",
      "etahallinta", "fjarstjórnun", "fjarstjornun"
    ],
    [
      "mezzanine card", "mezzanine", "mezz card", "mezz", "flexlom",
      "ocp card", "lom card", "carte mezzanine", "scheda mezzanine",
      "tarjeta mezzanine", "mezzaninecard", "mezzcard", "ocpcard", "lomcard",
      "cartemezzanine", "schedamezzanine", "tarjetamezzanine",
      "mezzanine kort", "mezzaninekort", "mezzaninkort", "mezzanine kortti",
      "mezzaninekortti"
    ],
    [
      "backplane", "back plane", "drive backplane", "hdd backplane",
      "backplane kaart", "backplane platine", "fond de panier",
      "scheda backplane", "placa backplane", "drivebackplane",
      "hddbackplane", "backplanekaart", "backplaneplatine",
      "schedabackplane", "placabackplane", "backplane kort", "backplanekort",
      "taustalevy"
    ],
    [
      "drive caddy", "caddy", "hdd caddy", "drive tray", "hdd tray",
      "drive carrier", "hdd carrier", "sled", "drive sled", "schijfhouder",
      "harddisk frame", "festplattenrahmen", "einbaurahmen",
      "hot swap rahmen", "wechselrahmen", "tiroir disque", "caddy disque",
      "slitta disco", "cassetto disco", "caddy disco", "bandeja de disco",
      "caddy de disco", "drivecaddy", "hddcaddy", "drivetray", "hddtray",
      "drivecarrier", "hddcarrier", "drivesled", "harddiskframe",
      "tiroirdisque", "caddydisque", "slittadisco", "cassettodisco",
      "caddydisco", "diskramme", "harddiskramme", "diskram", "hårddiskram",
      "haarddiskram", "harddiskram", "levykehikko", "kiintolevykehikko",
      "diskasleði", "diskasledi"
    ],
    [
      "hdd bracket", "drive bracket", "bracket", "harddisk beugel", "beugel",
      "festplattenhalterung", "halterung", "support disque", "staffa",
      "staffa hdd", "soporte disco", "hddbracket", "drivebracket",
      "harddiskbeugel", "supportdisque", "staffahdd", "soportedisco",
      "beslag", "harddiskbeslag", "monteringsbeslag", "fäste", "faeste",
      "faste", "hårddiskfäste", "haarddiskfaeste", "harddiskfaste",
      "brakett", "harddiskbrakett", "kiinnike", "levykiinnike", "festing",
      "diskafesting"
    ],
    [
      "rail kit", "rails", "rail", "rack rails", "slide rails",
      "geleiderails", "montagerails", "schienen", "rackschienen",
      "schienensatz", "gleitschienen", "kit de rails", "glissières",
      "kit guide", "guide rack", "binari", "rieles", "kit de rieles",
      "guías", "railkit", "rackrails", "sliderails", "glissieres",
      "kitguide", "guiderack", "guias", "skinner", "rackskinner",
      "glideskinner", "skinnesæt", "skinnesaet", "skenor", "rackskenor",
      "glidskenor", "skinnesett", "kiskot", "räkkikiskot", "raekkikiskot",
      "rakkikiskot", "liukukiskot", "brautir", "sleðabrautir", "sledabrautir"
    ],
    [
      "cable management arm", "cma", "kabelarm", "kabelmanagementarm",
      "kabelführungsarm", "bras de gestion des câbles", "bras de câbles",
      "braccio gestione cavi", "brazo de gestión de cables",
      "kabelfuehrungsarm", "kabelfuhrungsarm", "bras de gestion des cables",
      "bras de cables", "brazo de gestion de cables", "kabelføringsarm",
      "kabelfoeringsarm", "kabelforingsarm", "kabelhanteringsarm",
      "kaapelinhallintavarsi"
    ],
    [
      "riser card", "riser", "riser board", "pcie riser", "riserkaart",
      "riser karte", "carte riser", "scheda riser", "tarjeta riser",
      "risercard", "riserboard", "pcieriser", "riserkarte", "carteriser",
      "schedariser", "tarjetariser", "riser kort", "riserkort",
      "riser kortti", "riserkortti", "nousukortti"
    ],
    [
      "power distribution board", "pdb", "power board", "voedingsbord",
      "stromverteilerplatine", "carte de distribution d'alimentation",
      "scheda di alimentazione", "placa de alimentación", "powerboard",
      "placa de alimentacion", "strømfordelingskort", "stroemfordelingskort",
      "stromfordelingskort", "strömfördelningskort",
      "stroemfoerdelningskort", "stromfordelningskort", "virranjakokortti"
    ],
    [
      "kvm", "kvm switch", "kvm console", "rack console", "lcd console",
      "kvm schakelaar", "kvm umschalter", "commutateur kvm",
      "commutatore kvm", "conmutador kvm", "kvmswitch", "kvmconsole",
      "rackconsole", "lcdconsole", "kvmschakelaar", "kvmumschalter",
      "commutateurkvm", "commutatorekvm", "conmutadorkvm", "kvm omskifter",
      "kvmomskifter", "kvm växel", "kvmväxel", "kvm vaexel", "kvmvaexel",
      "kvm vaxel", "kvmvaxel", "kvm svitsj", "kvmsvitsj", "kvm kytkin",
      "kvmkytkin", "kvm skiptir", "kvmskiptir"
    ],
    [
      "graphics card", "video card", "gpu", "gfx", "graka", "videokaart",
      "grafische kaart", "grafikkaart", "grafikkarte", "carte graphique",
      "carte vidéo", "scheda video", "scheda grafica", "tarjeta gráfica",
      "tarjeta de video", "tarjeta de vídeo", "graphicscard", "videocard",
      "grafischekaart", "cartegraphique", "carte video", "cartevideo",
      "cartevidéo", "schedavideo", "schedagrafica", "tarjeta grafica",
      "tarjetagrafica", "tarjetagráfica", "grafikkort", "skjermkort",
      "näytönohjain", "naeytoenohjain", "naytonohjain", "näyttökortti",
      "naeyttoekortti", "nayttokortti", "skjákort", "skjakort"
    ],
    [
      "sound card", "audio card", "geluidskaart", "soundkarte", "carte son",
      "scheda audio", "tarjeta de sonido", "soundcard", "audiocard",
      "carteson", "schedaaudio", "lydkort", "ljudkort", "äänikortti",
      "aeaenikortti", "aanikortti", "hljóðkort", "hljodkort"
    ],
    [
      "card reader", "sd card reader", "kaartlezer", "kartenleser",
      "lecteur de cartes", "lettore di schede", "lector de tarjetas",
      "cardreader", "kortlæser", "kortlaeser", "kortläsare", "kortlaesare",
      "kortlasare", "kortleser", "kortinlukija", "kortalesari"
    ],
    [
      "case", "chassis", "computer case", "pc case", "server chassis",
      "behuizing", "kast", "computerkast", "pc kast", "gehäuse",
      "pc gehäuse", "boîtier", "boîtier pc", "châssis", "case pc", "telaio",
      "caja", "caja pc", "chasis", "gabinete", "computercase", "pccase",
      "serverchassis", "pckast", "gehaeuse", "gehause", "pc gehaeuse",
      "pc gehause", "pcgehaeuse", "pcgehause", "pcgehäuse", "boitier",
      "boitier pc", "boitierpc", "boîtierpc", "casepc", "cajapc", "kabinet",
      "computerkabinet", "pc kabinet", "pckabinet", "datorlåda",
      "datorlaada", "datorlada", "chassi", "kabinett", "pc kabinett",
      "pckabinett", "kotelo", "tietokonekotelo", "tölvukassi", "toelvukassi",
      "tolvukassi", "kassi"
    ],
    [
      "thermal paste", "thermal compound", "thermal pad", "koelpasta",
      "warmtegeleidingspasta", "koelpad", "wärmeleitpaste", "wärmeleitpad",
      "pâte thermique", "pasta termica", "pasta térmica", "thermalpaste",
      "thermalcompound", "thermalpad", "waermeleitpaste", "warmeleitpaste",
      "waermeleitpad", "warmeleitpad", "pate thermique", "patethermique",
      "pâtethermique", "pastatermica", "pastatérmica", "kølepasta",
      "koelepasta", "kolepasta", "kylpasta", "termisk pasta", "termiskpasta",
      "värmeledande pasta", "värmeledandepasta", "vaermeledande pasta",
      "vaermeledandepasta", "varmeledande pasta", "varmeledandepasta",
      "kjølepasta", "kjoelepasta", "kjolepasta", "lämpötahna",
      "laempoetahna", "lampotahna", "lämpötyyny", "laempoetyyny",
      "lampotyyny", "kælikrem", "kaelikrem", "hitaleiðnikrem",
      "hitaleidnikrem"
    ],
    [
      "io board", "i/o board", "usb board", "daughterboard",
      "daughter board", "dochterbord", "tochterplatine", "carte fille",
      "scheda figlia", "placa hija", "ioboard", "i o board", "i/oboard",
      "usbboard", "cartefille", "schedafiglia", "placahija", "datterkort",
      "dotterkort", "tytärkortti", "tytaerkortti", "tytarkortti",
      "dótturborð", "dotturbord"
    ],
    [
      "power button", "power button board", "aan uit knop", "aan/uit knop",
      "power knop", "einschaltknopf", "einschalttaste",
      "bouton d'alimentation", "pulsante di accensione",
      "botón de encendido", "powerbutton", "aan/uitknop", "powerknop",
      "boton de encendido", "tænd/sluk knap", "taend/sluk knap",
      "afbryderknap", "strømknap", "stroemknap", "stromknap", "strömbrytare",
      "stroembrytare", "strombrytare", "strömknapp", "stroemknapp",
      "stromknapp", "av/på knapp", "av/paa knapp", "av/pa knapp",
      "strømknapp", "virtapainike", "virtanappi", "aflhnappur",
      "kveikjuhnappur"
    ],
    [
      "cmos battery", "rtc battery", "bios battery", "cr2032", "knoopcel",
      "bios batterij", "cmos batterij", "knopfzelle", "bios batterie",
      "cmos batterie", "pile bios", "pile cmos", "batteria cmos",
      "batteria tampone", "pila bios", "pila cmos", "cmosbattery",
      "rtcbattery", "biosbattery", "biosbatterij", "cmosbatterij",
      "biosbatterie", "cmosbatterie", "pilebios", "pilecmos", "batteriacmos",
      "batteriatampone", "pilabios", "pilacmos", "knapcelle", "bios batteri",
      "biosbatteri", "cmos batteri", "cmosbatteri", "knappcell",
      "knappcelle", "nappiparisto", "bios paristo", "biosparisto",
      "hnapparafhlaða", "hnapparafhlada"
    ],
    [
      "bottom case", "bottom cover", "base cover", "lower case", "d cover",
      "onderkant", "onderbehuizing", "bodemplaat", "unterschale",
      "bodenabdeckung", "gehäuseunterteil", "coque inférieure",
      "capot inférieur", "scocca inferiore", "cover inferiore",
      "carcasa inferior", "tapa inferior", "bottomcase", "bottomcover",
      "basecover", "lowercase", "dcover", "gehaeuseunterteil",
      "gehauseunterteil", "coque inferieure", "coqueinferieure",
      "coqueinférieure", "capot inferieur", "capotinferieur",
      "capotinférieur", "scoccainferiore", "coverinferiore",
      "carcasainferior", "tapainferior", "bundplade", "bunddæksel",
      "bunddaeksel", "bottenplatta", "bottenskal", "bunnplate", "bunndeksel",
      "pohjakansi", "pohjalevy", "botnplata", "botnhlíf", "botnhlif"
    ],
    [
      "palmrest", "palm rest", "top case", "topcase", "top cover", "c cover",
      "handsteun", "polssteun", "handballenauflage", "oberschale",
      "repose-poignets", "coque supérieure", "poggiapolsi",
      "scocca superiore", "reposamuñecas", "reposamanos", "carcasa superior",
      "topcover", "ccover", "repose poignets", "reposepoignets",
      "coque superieure", "coquesuperieure", "coquesupérieure",
      "scoccasuperiore", "reposamunecas", "carcasasuperior",
      "håndledsstøtte", "haandledsstoette", "handledsstotte", "handledsstöd",
      "handledsstoed", "handledsstod", "håndleddsstøtte",
      "haandleddsstoette", "handleddsstotte", "kämmentuki", "kaemmentuki",
      "kammentuki", "úlnliðsstoð", "ulnlidsstod"
    ],
    [
      "lcd back cover", "lcd cover", "a cover", "back cover",
      "display cover", "top lid", "lid", "schermdeksel", "displaydeksel",
      "displaydeckel", "displayrückseite", "coque écran", "capot écran",
      "cover lcd", "cover posteriore lcd", "tapa de pantalla",
      "carcasa de pantalla", "lcdcover", "backcover", "displaycover",
      "toplid", "displayruckseite", "displayrueckseite", "coque ecran",
      "coqueecran", "coqueécran", "capot ecran", "capotecran", "capotécran",
      "coverlcd", "skærmlåg", "skaermlaag", "skaermlag", "skærmdæksel",
      "skaermdaeksel", "skärmlock", "skaermlock", "skarmlock", "skjermlokk",
      "skjermdeksel", "näytön kansi", "näytönkansi", "naeytoen kansi",
      "naeytoenkansi", "nayton kansi", "naytonkansi", "takakansi", "skjálok",
      "skjalok"
    ],
    [
      "bezel", "front bezel", "lcd bezel", "screen bezel", "display bezel",
      "b cover", "front panel", "frontpaneel", "frontplaat", "schermrand",
      "frontblende", "blende", "displayrahmen", "façade", "cache avant",
      "cadre écran", "frontalino", "pannello frontale", "cornice lcd",
      "bisel", "panel frontal", "marco de pantalla", "frontbezel",
      "lcdbezel", "screenbezel", "displaybezel", "bcover", "frontpanel",
      "facade", "cacheavant", "cadre ecran", "cadreecran", "cadreécran",
      "pannellofrontale", "cornicelcd", "panelfrontal", "skærmramme",
      "skaermramme", "frontramme", "skärmram", "skaermram", "skarmram",
      "frontram", "skjermramme", "näytön kehys", "näytönkehys",
      "naeytoen kehys", "naeytoenkehys", "nayton kehys", "naytonkehys",
      "etukehys", "skjárammi", "skjarammi"
    ],
    [
      "hinges", "hinge", "lcd hinges", "scharnier", "scharnieren",
      "scharniere", "displayscharnier", "charnière", "charnières",
      "cerniera", "cerniere", "bisagra", "bisagras", "lcdhinges",
      "charniere", "charnieres", "hængsel", "haengsel", "hængsler",
      "haengsler", "skærmhængsel", "skaermhaengsel", "gångjärn",
      "gaangjaern", "gangjarn", "skärmgångjärn", "skaermgaangjaern",
      "skarmgangjarn", "hengsel", "hengsler", "skjermhengsel", "sarana",
      "saranat", "näytön sarana", "näytönsarana", "naeytoen sarana",
      "naeytoensarana", "nayton sarana", "naytonsarana", "löm", "loem",
      "lom", "lamir"
    ],
    [
      "lcd cable", "display cable", "screen cable", "edp cable",
      "lvds cable", "edp", "lvds", "beeldschermkabel", "schermkabel",
      "lcd kabel", "displaykabel", "câble lcd", "nappe écran", "cavo lcd",
      "flat lcd", "cable lcd", "cable flex pantalla", "lcdcable",
      "displaycable", "screencable", "edpcable", "lvdscable", "lcdkabel",
      "cablelcd", "câblelcd", "nappe ecran", "nappeecran", "nappeécran",
      "cavolcd", "flatlcd", "skærmkabel", "skaermkabel", "skärmkabel",
      "skarmkabel", "skjermkabel", "näyttökaapeli", "naeyttoekaapeli",
      "nayttokaapeli", "skjákapall", "skjakapall"
    ],
    [
      "flex cable", "flat cable", "ribbon cable", "flexkabel", "lintkabel",
      "flachbandkabel", "nappe", "câble nappe", "cavo flat", "cavo a nastro",
      "cable plano", "cable flex", "flexcable", "flatcable", "ribboncable",
      "cable nappe", "cablenappe", "câblenappe", "cavoflat", "cableplano",
      "cableflex", "fladkabel", "flatkabel", "lattakaapeli", "nauhakaapeli",
      "borðakapall", "bordakapall"
    ],
    [
      "hdd cable", "hdd connector", "harddisk kabel", "festplattenkabel",
      "câble disque dur", "cavo hdd", "cable disco duro", "hddcable",
      "hddconnector", "harddiskkabel", "cable disque dur", "cavohdd",
      "hårddiskkabel", "haarddiskkabel", "kiintolevykaapeli", "diskakapall"
    ],
    [
      "dc jack", "power jack", "dc in", "dc-in", "charging port",
      "laadpoort", "voedingsaansluiting", "dc buchse", "strombuchse",
      "ladebuchse", "connecteur d'alimentation", "prise dc",
      "connettore di alimentazione", "jack dc", "conector de carga",
      "dcjack", "powerjack", "dcin", "chargingport", "dcbuchse", "prisedc",
      "jackdc", "strømstik", "stroemstik", "stromstik", "ladestik",
      "opladerstik", "laddkontakt", "laddningsport", "strømkontakt",
      "stroemkontakt", "stromkontakt", "ladekontakt", "ladeport",
      "virtaliitin", "latausliitin", "hleðslutengi", "hledslutengi",
      "rafmagnstengi"
    ],
    [
      "touchpad", "trackpad", "touch pad", "clickpad", "pavé tactile",
      "panel táctil", "pave tactile", "pavetactile", "pavétactile",
      "panel tactil", "paneltactil", "paneltáctil", "pegefelt", "styrplatta",
      "styreflate", "kosketuslevy", "snertiflötur", "snertifloetur",
      "snertiflotur"
    ],
    [
      "digitizer", "touch glass", "digitizer glas", "aanraakscherm",
      "touchglas", "vitre tactile", "vetro touch", "cristal táctil",
      "digitalizador", "touchglass", "digitizerglas", "vitretactile",
      "vetrotouch", "cristal tactil", "cristaltactil", "cristaltáctil",
      "berøringsglas", "beroeringsglas", "beroringsglas", "pekskärmsglas",
      "pekskaermsglas", "pekskarmsglas", "berøringsglass", "beroeringsglass",
      "beroringsglass", "kosketuslasi", "snertigler"
    ],
    [
      "webcam", "webcams", "camera", "web camera", "laptop camera",
      "camera module", "kamera", "caméra", "telecamera", "cámara",
      "cámara web", "webcamera", "laptopcamera", "cameramodule", "camara",
      "camara web", "camaraweb", "cámaraweb", "webkamera", "webbkamera",
      "verkkokamera", "vefmyndavél", "vefmyndavel", "myndavél", "myndavel"
    ],
    [
      "speakers", "speaker", "luidspreker", "luidsprekers", "lautsprecher",
      "haut-parleur", "haut-parleurs", "enceinte", "enceintes",
      "altoparlante", "altoparlanti", "altavoz", "altavoces", "haut parleur",
      "hautparleur", "haut parleurs", "hautparleurs", "højttaler",
      "hoejttaler", "hojttaler", "højttalere", "hoejttalere", "hojttalere",
      "högtalare", "hoegtalare", "hogtalare", "høyttaler", "hoeyttaler",
      "hoyttaler", "høyttalere", "hoeyttalere", "hoyttalere", "kaiutin",
      "kaiuttimet", "hátalari", "hatalari", "hátalarar", "hatalarar"
    ],
    [
      "microphone", "mic", "microfoon", "mikrofon", "microfono", "micrófono",
      "mikrofoner", "mikrofoni", "hljóðnemi", "hljodnemi"
    ],
    [
      "antenna", "antennas", "wifi antenna", "wlan antenna", "antenne",
      "antennes", "antenna wifi", "antena", "antenas", "wifiantenna",
      "wlanantenna", "antennawifi", "antenner", "antenn", "wifi antenne",
      "wifiantenne", "antenni", "antennit", "loftnet"
    ],
    [
      "wifi card", "wlan card", "wireless card", "wifi", "wi-fi", "wlan",
      "wireless", "wifi kaart", "wlan kaart", "draadloos", "wlan karte",
      "carte wifi", "scheda wifi", "tarjeta wifi", "wificard", "wlancard",
      "wirelesscard", "wi fi", "wifikaart", "wlankaart", "wlankarte",
      "cartewifi", "schedawifi", "tarjetawifi", "trådløst netkort",
      "trådløstnetkort", "traadloest netkort", "traadloestnetkort",
      "tradlost netkort", "tradlostnetkort", "wifi kort", "wifikort",
      "trådløs", "traadloes", "tradlos", "trådlöst nätverkskort",
      "trådlöstnätverkskort", "traadloest naetverkskort",
      "traadloestnaetverkskort", "tradlost natverkskort",
      "tradlostnatverkskort", "trådlös", "trådløst nettverkskort",
      "trådløstnettverkskort", "traadloest nettverkskort",
      "traadloestnettverkskort", "tradlost nettverkskort",
      "tradlostnettverkskort", "wlan kortti", "wlankortti",
      "langaton verkkokortti", "langatonverkkokortti", "langaton",
      "þráðlaust netkort", "þráðlaustnetkort", "thradlaust netkort",
      "thradlaustnetkort", "þráðlaust", "thradlaust"
    ],
    [
      "screws", "screw", "screw kit", "schroeven", "schroef", "schrauben",
      "schraube", "vis", "visserie", "viti", "vite", "tornillos", "tornillo",
      "screwkit", "skruer", "skrue", "skruesæt", "skruesaet", "skruvar",
      "skruv", "skruvsats", "skruesett", "ruuvi", "ruuvit", "ruuvisarja",
      "skrúfa", "skrufa", "skrúfur", "skrufur"
    ],
    [
      "rubber feet", "feet", "rubberen voetjes", "voetjes", "gummifüße",
      "pieds en caoutchouc", "piedini in gomma", "patas de goma",
      "rubberfeet", "rubberenvoetjes", "gummifuesse", "gummifuße",
      "gummifødder", "gummifoedder", "gummifodder", "gummifötter",
      "gummifoetter", "gummifotter", "gummiføtter", "kumijalat",
      "gúmmífætur", "gummifaetur"
    ],
    [
      "mouse", "mice", "muis", "muizen", "maus", "mäuse", "souris", "ratón",
      "raton", "ratones", "maeuse", "mause", "mus", "möss", "moess", "moss",
      "hiiri", "hiiret", "mús", "mýs", "mys"
    ],
    [
      "docking station", "dock", "docking", "dockingstation",
      "port replicator", "poortreplicator", "portreplikator",
      "station d'accueil", "réplicateur de ports", "replicatore di porte",
      "base de acoplamiento", "estación de acoplamiento",
      "replicador de puertos", "portreplicator", "replicateur de ports",
      "estacion de acoplamiento", "dockningsstation", "dokkingstasjon",
      "telakka", "telakointiasema", "tengikví", "tengikvi"
    ],
    [
      "usb hub", "hub", "usb verdeler", "usb splitter", "usb verteiler",
      "hub usb", "concentrateur usb", "concentrador usb", "usbhub",
      "usbverdeler", "usbsplitter", "usbverteiler", "hubusb",
      "concentrateurusb", "concentradorusb", "usb fordeler", "usbfordeler",
      "usb förgrenare", "usbförgrenare", "usb foergrenare", "usbfoergrenare",
      "usb forgrenare", "usbforgrenare", "usb jakaja", "usbjakaja",
      "usb keskitin", "usbkeskitin", "usb fjöltengi", "usbfjöltengi",
      "usb fjoeltengi", "usbfjoeltengi", "usb fjoltengi", "usbfjoltengi"
    ],
    [
      "usb stick", "usb flash drive", "flash drive", "thumb drive",
      "pen drive", "usb drive", "geheugenstick", "clé usb", "chiavetta usb",
      "pendrive", "memoria usb", "lápiz usb", "usbstick", "flashdrive",
      "thumbdrive", "usbdrive", "cle usb", "cleusb", "cléusb",
      "chiavettausb", "memoriausb", "lapiz usb", "lapizusb", "lápizusb",
      "usb nøgle", "usbnøgle", "usb noegle", "usbnoegle", "usb nogle",
      "usbnogle", "usb minne", "usbminne", "usb sticka", "usbsticka",
      "minnepinne", "usb pinne", "usbpinne", "muistitikku", "usb tikku",
      "usbtikku", "minnislykill", "usb lykill", "usblykill"
    ],
    [
      "memory card", "sd card", "micro sd", "microsd", "sd kaart",
      "geheugenkaart", "speicherkarte", "sd karte", "carte mémoire",
      "carte sd", "scheda di memoria", "scheda sd", "tarjeta de memoria",
      "tarjeta sd", "memorycard", "sdcard", "sdkaart", "sdkarte",
      "carte memoire", "cartememoire", "cartemémoire", "cartesd", "schedasd",
      "tarjetasd", "hukommelseskort", "sd kort", "sdkort", "minneskort",
      "minnekort", "muistikortti", "sd kortti", "sdkortti", "minniskort"
    ],
    [
      "external hard drive", "external hdd", "external drive",
      "externe harde schijf", "externe schijf", "externe festplatte",
      "disque dur externe", "hard disk esterno", "disco duro externo",
      "externalhdd", "externaldrive", "externeschijf", "externefestplatte",
      "ekstern harddisk", "eksternharddisk", "extern hårddisk",
      "externhårddisk", "extern haarddisk", "externhaarddisk",
      "extern harddisk", "externharddisk", "ulkoinen kiintolevy",
      "ulkoinenkiintolevy", "flakkari", "utanáliggjandi diskur",
      "utanáliggjandidiskur", "utanaliggjandi diskur", "utanaliggjandidiskur"
    ],
    [
      "headset", "headsets", "headphones", "koptelefoon", "kopfhörer",
      "casque", "casque audio", "cuffie", "cuffia", "auriculares",
      "kopfhoerer", "kopfhorer", "casqueaudio", "hovedtelefoner", "hörlurar",
      "hoerlurar", "horlurar", "hodetelefoner", "kuulokkeet",
      "kuulokemikrofoni", "heyrnartól", "heyrnartol"
    ],
    [
      "projector", "projectors", "beamer", "projecteur", "vidéoprojecteur",
      "proiettore", "proyector", "videoprojecteur", "projektor",
      "projektorer", "prosjektor", "projektori", "videotykki", "skjávarpi",
      "skjavarpi"
    ],
    [
      "stylus", "pen", "stylus pen", "active pen", "styluspen",
      "eingabestift", "stylet", "pennino", "lápiz óptico", "activepen",
      "lapiz optico", "lapizoptico", "lápizóptico", "digital pen",
      "digitalpen", "pekpenna", "pekepenn", "kosketuskynä", "kosketuskynae",
      "kosketuskyna", "snertipenni"
    ],
    [
      "laptop bag", "laptop sleeve", "laptoptas", "notebook bag", "tas",
      "laptoptasche", "notebooktasche", "sacoche", "sacoche ordinateur",
      "borsa notebook", "borsa pc", "funda portátil", "maletín", "laptopbag",
      "laptopsleeve", "notebookbag", "sacocheordinateur", "borsanotebook",
      "borsapc", "funda portatil", "fundaportatil", "fundaportátil",
      "maletin", "computertaske", "laptoptaske", "datorväska", "datorvaeska",
      "datorvaska", "laptopväska", "laptopvaeska", "laptopvaska", "pc veske",
      "pcveske", "laptopveske", "läppärilaukku", "laeppaerilaukku",
      "lapparilaukku", "tietokonelaukku", "fartölvutaska", "fartoelvutaska",
      "fartolvutaska", "tölvutaska", "toelvutaska", "tolvutaska"
    ],
    [
      "laptop lock", "kensington lock", "cable lock", "kensington",
      "laptopslot", "kabelschloss", "câble antivol", "antivol",
      "cavo di sicurezza", "candado portátil", "laptoplock",
      "kensingtonlock", "cablelock", "cable antivol", "cableantivol",
      "câbleantivol", "candado portatil", "candadoportatil",
      "candadoportátil", "kabellås", "kabellaas", "kabellas", "laptoplås",
      "laptoplaas", "laptoplas", "datorlås", "datorlaas", "datorlas",
      "pc lås", "pclås", "pc laas", "pclaas", "pc las", "pclas",
      "kaapelilukko", "tietokonelukko", "tölvulás", "toelvulas", "tolvulas"
    ],
    [
      "license", "licence", "licenses", "licentie", "licenties", "lizenz",
      "lizenzen", "licenza", "licenze", "licencia", "licencias", "software",
      "licens", "licenser", "lisens", "lisenser", "lisenssi", "lisenssit",
      "hugbúnaðarleyfi", "hugbunadarleyfi"
    ],
    [
      "network cable", "ethernet cable", "lan cable", "patch cable", "utp",
      "utp cable", "cat5", "cat5e", "cat6", "cat6a", "cat7", "rj45",
      "rj45 cable", "netwerkkabel", "utp kabel", "patchkabel",
      "netzwerkkabel", "lan kabel", "câble réseau", "câble ethernet",
      "cordon rj45", "cavo di rete", "cavo ethernet", "cable de red",
      "cable ethernet", "networkcable", "ethernetcable", "lancable",
      "patchcable", "utpcable", "rj45cable", "utpkabel", "lankabel",
      "cable reseau", "cablereseau", "câbleréseau", "cableethernet",
      "câbleethernet", "cordonrj45", "cavoethernet", "netværkskabel",
      "netvaerkskabel", "nätverkskabel", "naetverkskabel", "natverkskabel",
      "nettverkskabel", "verkkokaapeli", "ethernet kaapeli",
      "ethernetkaapeli", "netkapall"
    ],
    [
      "fiber cable", "fibre cable", "fiber optic cable", "fiber patch",
      "glasvezelkabel", "glasvezel", "lwl kabel", "glasfaserkabel",
      "glasfaser", "câble fibre optique", "fibre optique",
      "cavo in fibra ottica", "fibra ottica", "cable de fibra óptica",
      "fibra óptica", "fibercable", "fibrecable", "fiberpatch", "lwlkabel",
      "cable fibre optique", "fibreoptique", "fibraottica",
      "cable de fibra optica", "fibra optica", "fibraoptica", "fibraóptica",
      "fiberkabel", "lyslederkabel", "optisk fiberkabel", "optiskfiberkabel",
      "valokuitukaapeli", "kuitukaapeli", "valokuitu", "ljósleiðari",
      "ljosleidari", "ljósleiðarakapall", "ljosleidarakapall"
    ],
    [
      "usb cable", "usb kabel", "usb c cable", "usb-c cable", "usb c kabel",
      "câble usb", "cavo usb", "cable usb", "usbcable", "usbkabel",
      "usb-ccable", "usbc cable", "usbccable", "cableusb", "câbleusb",
      "cavousb", "usb kaapeli", "usbkaapeli", "usb kapall", "usbkapall"
    ],
    [
      "hdmi", "hdmi cable", "hdmi kabel", "câble hdmi", "cavo hdmi",
      "cable hdmi", "hdmicable", "hdmikabel", "cablehdmi", "câblehdmi",
      "cavohdmi", "hdmi kaapeli", "hdmikaapeli", "hdmi kapall", "hdmikapall"
    ],
    [
      "displayport", "dp", "displayport cable", "dp cable",
      "displayport kabel", "dp kabel", "câble displayport",
      "cavo displayport", "cable displayport", "displayportcable", "dpcable",
      "displayportkabel", "dpkabel", "cabledisplayport", "câbledisplayport",
      "cavodisplayport", "displayport kaapeli", "displayportkaapeli"
    ],
    [
      "vga", "vga cable", "vga kabel", "d-sub", "câble vga", "cavo vga",
      "cable vga", "vgacable", "vgakabel", "d sub", "dsub", "cablevga",
      "câblevga", "cavovga", "vga kaapeli", "vgakaapeli"
    ],
    [
      "sata cable", "sata", "sata kabel", "câble sata", "cavo sata",
      "cable sata", "satacable", "satakabel", "cablesata", "câblesata",
      "cavosata", "sata kaapeli", "satakaapeli"
    ],
    [
      "sas cable", "sas", "mini sas", "sas kabel", "câble sas", "cavo sas",
      "cable sas", "sascable", "minisas", "saskabel", "cablesas", "câblesas",
      "cavosas", "sas kaapeli", "saskaapeli"
    ],
    [
      "converter", "adapter cable", "verloopstekker", "verloop",
      "adapterkabel", "konverter", "convertisseur", "câble adaptateur",
      "convertitore", "cavo adattatore", "convertidor", "cable adaptador",
      "adaptercable", "cable adaptateur", "cableadaptateur",
      "câbleadaptateur", "cavoadattatore", "cableadaptador", "omvandlare",
      "omformer", "adapteri", "sovitin", "sovitinkaapeli", "millistykki"
    ],
    [
      "switch", "switches", "network switch", "netwerkswitch",
      "netzwerk switch", "switch réseau", "commutateur", "switch di rete",
      "conmutador", "switch de red", "networkswitch", "netzwerkswitch",
      "switch reseau", "switchreseau", "switchréseau", "netværksswitch",
      "netvaerksswitch", "nätverksswitch", "naetverksswitch",
      "natverksswitch", "nettverkssvitsj", "svitsj", "kytkin",
      "verkkokytkin", "netskiptir"
    ],
    [
      "router", "routers", "routeur", "routeurs", "enrutador", "enrutadores",
      "ruteador", "routere", "routrar", "ruter", "rutere", "reititin",
      "reitittimet", "beinir"
    ],
    [
      "firewall", "firewalls", "fw", "pare-feu", "cortafuegos", "pare feu",
      "parefeu", "brandvæg", "brandvaeg", "brandvägg", "brandvaegg",
      "brandvagg", "brannmur", "palomuuri", "eldveggur"
    ],
    [
      "access point", "access points", "ap", "wap", "wireless access point",
      "wlan access point", "draadloos toegangspunt", "point d'accès",
      "borne wifi", "punto di accesso", "punto de acceso", "accesspoint",
      "accesspoints", "draadloostoegangspunt", "point d'acces", "bornewifi",
      "adgangspunkt", "trådløst adgangspunkt", "trådløstadgangspunkt",
      "traadloest adgangspunkt", "traadloestadgangspunkt",
      "tradlost adgangspunkt", "tradlostadgangspunkt", "åtkomstpunkt",
      "aatkomstpunkt", "atkomstpunkt", "trådlös åtkomstpunkt",
      "trådlösåtkomstpunkt", "traadloes aatkomstpunkt",
      "traadloesaatkomstpunkt", "tradlos atkomstpunkt",
      "tradlosatkomstpunkt", "tilgangspunkt", "trådløst tilgangspunkt",
      "trådløsttilgangspunkt", "traadloest tilgangspunkt",
      "traadloesttilgangspunkt", "tradlost tilgangspunkt",
      "tradlosttilgangspunkt", "tukiasema", "langaton tukiasema",
      "langatontukiasema", "aðgangspunktur", "adgangspunktur"
    ],
    [
      "modem", "modems", "módem", "modemer", "modeemi", "mótald", "motald"
    ],
    [
      "transceiver", "transceivers", "sfp", "sfp+", "sfp module", "gbic",
      "qsfp", "xfp", "optical module", "glasvezel module", "module sfp",
      "émetteur-récepteur", "modulo sfp", "ricetrasmettitore", "módulo sfp",
      "transceptor", "sfpmodule", "opticalmodule", "glasvezelmodule",
      "modulesfp", "emetteur recepteur", "emetteur-recepteur",
      "emetteurrecepteur", "émetteur récepteur", "émetteurrécepteur",
      "modulosfp", "módulosfp", "sfp modul", "sfpmodul", "sfp moduuli",
      "sfpmoduuli"
    ],
    [
      "patch panel", "patchpaneel", "patchfeld", "panneau de brassage",
      "pannello patch", "panel de parcheo", "patchpanel", "pannellopatch",
      "kytkentäpaneeli", "kytkentaepaneeli", "kytkentapaneeli"
    ],
    [
      "poe", "poe injector", "power over ethernet", "poe injecteur",
      "injecteur poe", "iniettore poe", "inyector poe", "poeinjector",
      "poeinjecteur", "injecteurpoe", "iniettorepoe", "inyectorpoe",
      "poe injektor", "poeinjektor", "poe injektori", "poeinjektori"
    ],
    [
      "toner", "toners", "toner cartridge", "tonercartridge",
      "tonercassette", "tonerkartusche", "cartouche de toner",
      "cartouche toner", "cartuccia toner", "cartucho de tóner", "tóner",
      "cartouchetoner", "cartucciatoner", "cartucho de toner", "tonerpatron",
      "tonerpatroner", "tonerkassett", "tonerkassetter", "värikasetti",
      "vaerikasetti", "varikasetti", "väriainekasetti", "vaeriainekasetti",
      "variainekasetti", "väriaine", "vaeriaine", "variaine", "prenthylki",
      "dufthylki"
    ],
    [
      "ink", "ink cartridge", "inkt", "inktcartridge", "inktpatroon",
      "inktpatronen", "tinte", "tintenpatrone", "druckerpatrone", "encre",
      "cartouche d'encre", "inchiostro", "cartuccia d'inchiostro", "tinta",
      "cartucho de tinta", "inkcartridge", "blæk", "blaek", "blækpatron",
      "blaekpatron", "blækpatroner", "blaekpatroner", "bläck", "blaeck",
      "black", "bläckpatron", "blaeckpatron", "blackpatron", "bläckpatroner",
      "blaeckpatroner", "blackpatroner", "blekk", "blekkpatron",
      "blekkpatroner", "muste", "mustekasetti", "mustepatruuna", "blek",
      "blekhylki"
    ],
    [
      "drum", "drums", "drum unit", "drum kit", "imaging drum",
      "imaging unit", "opc", "opc drum", "drumunit", "drumeenheid",
      "trommel", "bildtrommel", "trommeleinheit", "bildeinheit", "tambour",
      "unité tambour", "tamburo", "unità tamburo", "tambor",
      "unidad de tambor", "drumkit", "imagingdrum", "imagingunit", "opcdrum",
      "unite tambour", "unitetambour", "unitétambour", "unita tamburo",
      "unitatamburo", "unitàtamburo", "tromle", "tromleenhed", "trumma",
      "trumenhet", "bildtrumma", "trommelenhet", "rumpu", "rumpuyksikkö",
      "rumpuyksikkoe", "rumpuyksikko", "kuvarumpu", "tromla", "myndtromla"
    ],
    [
      "waste toner", "waste toner box", "waste toner container",
      "toner collection unit", "afvaltoner", "afvaltonerbak", "restbak",
      "resttonerbehälter", "tonerauffangbehälter", "récupérateur de toner",
      "bac de récupération", "collettore toner", "vaschetta di recupero",
      "depósito de tóner residual", "recipiente de tóner residual",
      "wastetoner", "resttonerbehaelter", "resttonerbehalter",
      "tonerauffangbehaelter", "tonerauffangbehalter",
      "recuperateur de toner", "bac de recuperation", "collettoretoner",
      "deposito de toner residual", "recipiente de toner residual",
      "spildtoner", "spildtonerbeholder", "spilltoner", "toneruppsamlare",
      "uppsamlingsbehållare", "uppsamlingsbehaallare",
      "uppsamlingsbehallare", "spilltonerbeholder", "tonersamler",
      "hukkavärisäiliö", "hukkavaerisaeilioe", "hukkavarisailio",
      "jätevärisäiliö", "jaetevaerisaeilioe", "jatevarisailio",
      "afgangsdufthólf", "afgangsduftholf"
    ],
    [
      "developer", "developer unit", "ontwikkelaar", "ontwikkeleenheid",
      "entwickler", "entwicklereinheit", "développeur",
      "unité de développement", "sviluppatore", "unità di sviluppo",
      "revelador", "unidad de revelado", "developerunit", "developpeur",
      "unite de developpement", "unita di sviluppo", "fremkalder",
      "fremkalderenhed", "framkallare", "framkallningsenhet", "fremkaller",
      "fremkallerenhet", "kehite", "kehitysyksikkö", "kehitysyksikkoe",
      "kehitysyksikko", "framköllunareining", "framkoellunareining",
      "framkollunareining"
    ],
    [
      "printhead", "print head", "printheads", "printkop", "printkoppen",
      "druckkopf", "tête d'impression", "testina", "testina di stampa",
      "cabezal", "cabezal de impresión", "tete d'impression",
      "cabezal de impresion", "printhoved", "skrivehoved", "skrivhuvud",
      "skrivehode", "tulostuspää", "tulostuspaeae", "tulostuspaa",
      "prenthaus"
    ],
    [
      "formatter", "formatter board", "formatter pca", "formatter pcb",
      "main controller", "formatterkaart", "formatter platine",
      "carte formateur", "scheda formatter", "placa formateadora",
      "formatterboard", "formatterpca", "formatterpcb", "maincontroller",
      "formatterplatine", "carteformateur", "schedaformatter",
      "placaformateadora", "formatterkort", "formatterkortti"
    ],
    [
      "transfer roller", "transferrol", "transferwalze",
      "rouleau de transfert", "rullo di trasferimento",
      "rodillo de transferencia", "transferroller", "overførselsrulle",
      "overfoerselsrulle", "overforselsrulle", "transferrulle",
      "överföringsvals", "oeverfoeringsvals", "overforingsvals",
      "transfervals", "overføringsvalse", "overfoeringsvalse",
      "overforingsvalse", "transferrull", "siirtotela", "flutningsvals"
    ],
    [
      "pickup roller", "pick up roller", "pick roller", "feed roller",
      "invoerrol", "oppakrol", "einzugsrolle", "aufnahmerolle",
      "rouleau d'entraînement", "rouleau de prise papier",
      "rullo di prelievo", "rullo pescaggio", "rodillo de arrastre",
      "rodillo de alimentación", "pickuproller", "pickroller", "feedroller",
      "rouleau d'entrainement", "rullopescaggio", "rodillo de alimentacion",
      "fremføringsrulle", "fremfoeringsrulle", "fremforingsrulle",
      "papirindføringsrulle", "papirindfoeringsrulle",
      "papirindforingsrulle", "inmatningsrulle", "matarrulle", "materrull",
      "innmatingsrull", "syöttötela", "syoettoetela", "syottotela",
      "nostotela", "matarrúlla", "matarrulla"
    ],
    [
      "separation pad", "separation roller", "scheidingspad",
      "scheidingsrol", "trennpad", "trennrolle", "patin de séparation",
      "rouleau de séparation", "pad di separazione", "rullo di separazione",
      "almohadilla de separación", "rodillo de separación", "separationpad",
      "separationroller", "patin de separation", "rouleau de separation",
      "almohadilla de separacion", "rodillo de separacion",
      "separationspude", "separationsrulle", "separationsdyna",
      "separasjonspute", "separasjonsrull", "erottelutyyny", "erottelutela",
      "aðskilnaðarpúði", "adskilnadarpudi"
    ],
    [
      "pressure roller", "lower roller", "lower pressure roller",
      "aandrukrol", "drukrol", "andruckrolle", "druckwalze",
      "rouleau presseur", "rullo pressore", "rodillo de presión",
      "pressureroller", "lowerroller", "rouleaupresseur", "rullopressore",
      "rodillo de presion", "trykrulle", "trykvalse", "tryckvals",
      "tryckrulle", "trykkvalse", "trykkrull", "painetela", "þrýstivals",
      "thrystivals"
    ],
    [
      "heat roller", "upper roller", "fuser roller", "verwarmingsrol",
      "heizwalze", "fixierwalze", "rouleau chauffant", "rullo caldo",
      "rodillo de calor", "rodillo térmico", "heatroller", "upperroller",
      "fuserroller", "rouleauchauffant", "rullocaldo", "rodillo termico",
      "rodillotermico", "rodillotérmico", "varmevalse", "varmerulle",
      "värmevals", "vaermevals", "varmevals", "lämpötela", "laempoetela",
      "lampotela", "hitavals"
    ],
    [
      "fuser film", "fuser sleeve", "fixing film", "fixeerfilm",
      "fixierfolie", "film de fusion", "film fusore", "película del fusor",
      "fuserfilm", "fusersleeve", "fixingfilm", "filmfusore",
      "pelicula del fusor", "fikseringsfilm", "fixeringsfilm",
      "kiinnityskalvo"
    ],
    [
      "paper tray", "tray", "trays", "cassette", "input tray", "papierlade",
      "papierbak", "lade", "papierfach", "papierkassette", "fach",
      "bac papier", "bac", "cassetto carta", "vassoio carta", "vassoio",
      "bandeja de papel", "bandeja", "casete", "papertray", "inputtray",
      "bacpapier", "cassettocarta", "vassoiocarta", "papirbakke", "bakke",
      "papirskuffe", "papperskassett", "pappersfack", "fack", "papirskuff",
      "skuff", "kassett", "paperilokero", "lokero", "paperikasetti",
      "pappírsbakki", "pappirsbakki", "bakki"
    ],
    [
      "output tray", "output bin", "uitvoerlade", "uitvoerbak",
      "ausgabefach", "bac de sortie", "vassoio di uscita",
      "bandeja de salida", "outputtray", "outputbin", "udbakke",
      "udskriftsbakke", "utmatningsfack", "utfack", "utskuff",
      "utmatingsskuff", "tulostelokero", "luovutuslokero", "úttaksbakki",
      "uttaksbakki"
    ],
    [
      "paper feeder", "optional tray", "extra tray", "hci",
      "high capacity input", "extra lade", "papierinvoer", "papierzufuhr",
      "zusatzfach", "bac optionnel", "alimentatore carta",
      "alimentador de papel", "paperfeeder", "optionaltray", "extratray",
      "extralade", "bacoptionnel", "alimentatorecarta", "ekstra bakke",
      "ekstrabakke", "arkføder", "arkfoeder", "arkfoder", "extra fack",
      "extrafack", "pappersmatare", "ekstra skuff", "ekstraskuff",
      "papirmater", "lisälokero", "lisaelokero", "lisalokero",
      "paperinsyöttölaite", "paperinsyoettoelaite", "paperinsyottolaite",
      "aukabakki"
    ],
    [
      "duplex", "duplex unit", "duplexer", "duplexeenheid", "duplexeinheit",
      "recto verso", "unité recto verso", "fronte retro",
      "unità fronte retro", "dúplex", "unidad dúplex", "duplexunit",
      "rectoverso", "unite recto verso", "fronteretro", "unita fronte retro",
      "unidad duplex", "unidadduplex", "unidaddúplex", "duplexenhed",
      "duplexenhet", "dobbeltsidet", "dubbelsidig", "tosidig",
      "kaksipuolinen", "kaksipuolisyksikkö", "kaksipuolisyksikkoe",
      "kaksipuolisyksikko", "tvíhliða", "tvihlida"
    ],
    [
      "adf", "automatic document feeder", "document feeder",
      "documentinvoer", "automatische documentinvoer", "dokumenteneinzug",
      "vorlageneinzug", "chargeur de documents",
      "chargeur automatique de documents", "alimentatore automatico",
      "alimentatore documenti", "alimentador de documentos",
      "alimentador automático de documentos", "documentfeeder",
      "automatischedocumentinvoer", "alimentatoreautomatico",
      "alimentatoredocumenti", "alimentador automatico de documentos",
      "dokumentføder", "dokumentfoeder", "dokumentfoder",
      "automatisk dokumentføder", "automatiskdokumentføder",
      "automatisk dokumentfoeder", "automatiskdokumentfoeder",
      "automatisk dokumentfoder", "automatiskdokumentfoder",
      "dokumentmatare", "automatisk dokumentmatare",
      "automatiskdokumentmatare", "dokumentmater",
      "automatisk dokumentmater", "automatiskdokumentmater",
      "arkinsyöttölaite", "arkinsyoettoelaite", "arkinsyottolaite",
      "automaattinen arkinsyöttölaite", "automaattinenarkinsyöttölaite",
      "automaattinen arkinsyoettoelaite", "automaattinenarkinsyoettoelaite",
      "automaattinen arkinsyottolaite", "automaattinenarkinsyottolaite",
      "asiakirjansyöttölaite", "asiakirjansyoettoelaite",
      "asiakirjansyottolaite", "skjalamatari"
    ],
    [
      "finisher", "stapler", "stapler unit", "stapler finisher",
      "nietmachine", "afwerkeenheid", "hefter", "hefteinheit", "agrafeuse",
      "module de finition", "finitore", "pinzatrice", "grapadora",
      "finalizador", "staplerunit", "staplerfinisher", "hæftemaskine",
      "haeftemaskine", "hæfteenhed", "haefteenhed", "efterbehandlingsenhed",
      "häftapparat", "haeftapparat", "haftapparat", "häftenhet",
      "haeftenhet", "haftenhet", "efterbehandlare", "stiftemaskin",
      "stifteenhet", "etterbehandler", "viimeistelijä", "viimeistelijae",
      "viimeistelija", "nitoja", "nitojayksikkö", "nitojayksikkoe",
      "nitojayksikko", "heftari"
    ],
    [
      "staples", "staple cartridge", "nietjes", "nietcassette",
      "heftklammern", "agrafes", "cartouche d'agrafes", "punti metallici",
      "grapas", "cartucho de grapas", "staplecartridge", "puntimetallici",
      "hæfteklammer", "haefteklammer", "hæfteklammepatron",
      "haefteklammepatron", "häftklamrar", "haeftklamrar", "haftklamrar",
      "häftklammerkassett", "haeftklammerkassett", "haftklammerkassett",
      "stifter", "stiftekassett", "niitit", "niittikasetti", "heftivír",
      "heftivir", "hefti"
    ],
    [
      "gear", "gears", "tandwiel", "tandwielen", "zahnrad", "zahnräder",
      "engrenage", "engrenages", "pignon", "ingranaggio", "ingranaggi",
      "engranaje", "engranajes", "zahnrader", "zahnraeder", "tandhjul",
      "kugghjul", "tannhjul", "hammaspyörä", "hammaspyoerae", "hammaspyora",
      "hammaspyörät", "hammaspyoeraet", "hammaspyorat", "tannhjól",
      "tannhjol"
    ],
    [
      "motor", "motors", "drive motor", "motoren", "moteur", "moteurs",
      "motore", "motori", "motores", "drivemotor", "motorer", "drivmotor",
      "moottori", "moottorit", "mótor"
    ],
    [
      "sensor", "sensors", "sensoren", "capteur", "capteurs", "sensore",
      "sensori", "sensores", "sensorer", "givare", "anturi", "anturit",
      "skynjari"
    ],
    [
      "solenoid", "solenoids", "solenoïde", "hubmagnet", "solenoide",
      "solenoider", "solenoidi", "segulloki"
    ]

  ];

  const originalParameter = "spi_original";

  function normalize(value) {
    return String(value)
      .normalize("NFKC")
      .replace(/[‐‑‒–—]/g, "-")
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();
  }

  function quote(value) {
    return '"' + value
      .replace(/\\/g, "\\\\")
      .replace(/"/g, '\\"') + '"';
  }

  const groups = synonymGroups.map(function (group) {
    return Array.from(new Set(group.map(normalize)));
  });

  const entries = [];

  groups.forEach(function (group, groupIndex) {
    group.forEach(function (phrase) {
      entries.push({
        words: phrase.split(" "),
        groupIndex: groupIndex
      });
    });
  });

  entries.sort(function (a, b) {
    return b.words.length - a.words.length ||
      b.words.join(" ").length - a.words.join(" ").length;
  });

  function phraseClause(phrase) {
    const value = quote(phrase);
    return "(title:" + value + " OR body:" + value + ")";
  }

  function buildParts(words) {
    const clauses = [];
    const usedGroups = new Set();
    let expanded = false;
    let index = 0;

    while (index < words.length) {
      const match = entries.find(function (entry) {
        return entry.words.every(function (word, offset) {
          return words[index + offset] === word;
        });
      });

      if (match) {
        expanded = true;

        if (!usedGroups.has(match.groupIndex)) {
          clauses.push(
            "(" +
            groups[match.groupIndex].map(phraseClause).join(" OR ") +
            ")"
          );
          usedGroups.add(match.groupIndex);
        }

        index += match.words.length;
      } else {
        clauses.push(phraseClause(words[index]));
        index++;
      }
    }

    return {
      query: clauses.join(" AND "),
      expanded: expanded
    };
  }

  function modelClause(model) {
    const variants = new Set([model]);
    const match = model.match(
      /^([A-Z]{1,4})-?(\d{3,5}[A-Z]{0,4}(?:-\d{1,4}[A-Z]{0,3})?)( Gen\d+[A-Z]?)?$/
    );

    if (match) {
      const suffix = match[3] || "";
      variants.add(match[1] + match[2] + suffix);
      variants.add(match[1] + "-" + match[2] + suffix);
    }

    return "(" + Array.from(variants).map(function (value) {
      return "tag:" + quote(value);
    }).join(" OR ") + ")";
  }

  function rewriteQuery(raw) {
    const text = normalize(raw);
    if (!text) return null;

    // Keep deliberately entered advanced syntax unchanged.
    if (
      /[:"*()\\]/.test(text) ||
      /\b(?:AND|OR|NOT)\b/.test(raw) ||
      /(^|\s)-/.test(text)
    ) {
      return null;
    }

    const words = text.split(" ");
    const modelPattern =
      /^[a-z]{1,4}-?\d{3,5}[a-z]{0,4}(?:-\d{1,4}[a-z]{0,3})?$/i;
    const modelIndexes = [];

    words.forEach(function (word, index) {
      if (modelPattern.test(word)) modelIndexes.push(index);
    });

    if (modelIndexes.length > 1) return null;

    if (!modelIndexes.length) {
      const parts = buildParts(words);
      return parts.expanded ? parts.query : null;
    }

    const modelIndex = modelIndexes[0];
    let consumed = 1;
    let model = words[modelIndex].toUpperCase();

    const next = words[modelIndex + 1] || "";
    const afterNext = words[modelIndex + 2] || "";
    const generation = next.match(/^gen(\d+[a-z]?)$/i);

    if (generation) {
      model += " Gen" + generation[1].toUpperCase();
      consumed = 2;
    } else if (
      next === "gen" &&
      /^\d+[a-z]?$/i.test(afterNext)
    ) {
      model += " Gen" + afterNext.toUpperCase();
      consumed = 3;
    }

    const before = words.slice(0, modelIndex);
    const after = words.slice(modelIndex + consumed);

    if (!before.length && !after.length) return null;

    const clauses = [];
    if (before.length) clauses.push(buildParts(before).query);
    if (after.length) clauses.push(buildParts(after).query);
    clauses.push(modelClause(model));

    return clauses.join(" AND ");
  }

  function restoreVisibleSearch() {
    const url = new URL(window.location.href);
    const original = url.searchParams.get(originalParameter);
    const expanded = url.searchParams.get("q");

    // Only trust the display value if it matches our rewrite.
    if (
      !original ||
      !expanded ||
      rewriteQuery(original) !== expanded
    ) {
      return;
    }

    document.querySelectorAll(
      'form[action*="/search"] input[name="q"]'
    ).forEach(function (input) {
      input.value = original;
    });

    // Dawn uses search.terms in results and no-results messages.
    const candidates = [
      expanded,
      expanded.replace(/"/g, "")
    ].sort(function (a, b) {
      return b.length - a.length;
    });

    document.querySelectorAll(
      ".template-search h1, " +
      ".template-search h2, " +
      ".template-search [role='status']"
    ).forEach(function (element) {
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT
      );

      let node;
      while ((node = walker.nextNode())) {
        for (const candidate of candidates) {
          if (node.nodeValue.includes(candidate)) {
            node.nodeValue = node.nodeValue
              .split(candidate)
              .join(original);
            break;
          }
        }
      }
    });

    // Carry the original wording through filters and pagination.
    document.querySelectorAll(
      'a[href], form[action*="/search"]'
    ).forEach(function (element) {
      if (element.tagName === "A") {
        const link = new URL(element.href, window.location.href);

        if (
          link.origin === url.origin &&
          link.pathname === url.pathname &&
          link.searchParams.get("q") === expanded
        ) {
          link.searchParams.set(originalParameter, original);
          element.href = link.href;
        }
      }
    });

    document.querySelectorAll(
      'form[action*="/search"], facet-filters-form form'
    ).forEach(function (form) {
      if (form.querySelector(
        'input[name="' + originalParameter + '"]'
      )) return;

      const hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = originalParameter;
      hidden.value = original;
      form.appendChild(hidden);
    });
  }

  document.addEventListener("submit", function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const input = form.querySelector('input[name="q"]');

    // Only rewrite a customer-facing search field.
    if (!input || input.type === "hidden") return;

    const action = new URL(
      form.getAttribute("action") || window.location.href,
      window.location.href
    );

    if (
      action.origin !== window.location.origin ||
      !/\/search\/?$/.test(action.pathname)
    ) return;

    const original = input.value.trim();
    const rewritten = rewriteQuery(original);

    event.preventDefault();
    event.stopImmediatePropagation();

    const formData = new FormData(form);
    const fieldNames = new Set();

    formData.forEach(function (_, name) {
      fieldNames.add(name);
    });

    fieldNames.forEach(function (name) {
      action.searchParams.delete(name);
    });

    action.searchParams.delete(originalParameter);

    formData.forEach(function (value, name) {
      if (
        typeof value === "string" &&
        name !== "q" &&
        name !== originalParameter
      ) {
        action.searchParams.append(name, value);
      }
    });

    action.searchParams.set("q", rewritten || original);

    if (rewritten) {
      action.searchParams.set(originalParameter, original);
      action.searchParams.delete("options[prefix]");
    }

    action.searchParams.set("type", "product");
    action.searchParams.delete("page");

    window.location.assign(action.href);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      restoreVisibleSearch
    );
  } else {
    restoreVisibleSearch();
  }

  window.addEventListener("pageshow", restoreVisibleSearch);

  // Dawn can replace results after filtering or sorting.
  let restoreScheduled = false;
  const observer = new MutationObserver(function (records) {
    if (!records.some(function (record) {
      return record.addedNodes.length;
    })) return;

    if (restoreScheduled) return;
    restoreScheduled = true;

    window.requestAnimationFrame(function () {
      restoreScheduled = false;
      restoreVisibleSearch();
    });
  });
})();